import React, { Component, Fragment, useEffect } from 'react';
//import { render } from 'react-dom';
//import Hello from './Hello';
import './style.css';
import '../assets/css/formulario.css'
import Swal from 'sweetalert2';
import Loading from "react-fullscreen-loading";
import ReCAPTCHA from 'react-google-recaptcha';
import TerminosCondicionesQuimica, { TerminosCondicionesQuimicaString, TratamientoDatosQuimicaString } from './TerminosCondicionesQuimica.js';

export class FormularioQuimica extends Component {
    URL_FRONT = process.env.REACT_APP_URI_SERVER;
    //valorExternos = 15;
    //valorInternos = 10;

    constructor(props) {
        super(props);
        var idcongreso = -1;
        var aceptaRegistro = true;

        this.state =
        {
            valorExternos: 2,
            valorInternos: 1,
            options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
            recaptchaToken: null,
            evento: idcongreso,
            titulo: "",
            isDespuesRegInicio: aceptaRegistro,
            fechaInicioInsc: "",
            fechaFinInsc: "",
            isAntesRegFin: aceptaRegistro,
            anioEvento: "",
            isRegistrado: false,
            onProcess: false,
            datosFormulario: {
                nombres: "",
                apellidos: "",
                tipoIdentificacion: "C",
                numeroIdentificacion: "",
                paises: [], //json completo de paises y ciudades
                paisId: null, //guarda id de pais
                paisNom: "",
                ciudades: [], //json completo de ciudades segun pais seleccionado
                ciudadId: "", //guarda id de ciudad
                ciudadNom: "",
                tipoInstitucion: "",
                tipoInstitucionDet: "",
                nombreInstitucion: "",
                tipoParticipante: "",
                tipoParticipanteDet: "",
                tipoEstudiante: null,
                tipoEstudianteDet: "",
                email: "",
                celular: "",
                tipoParticipacion: "A",
                tipoParticipacionDet: "Asistente",
                tipoAsistencia: "P",
                presentacion: "",
                modoInformado: "O",
                modoInformadoDet: "Otros",
                otroModoInformado: "",
                esEspol: "N",
                esEspolDet: "No",
                esPostgrado: "N",
                esPostgradoDet: "No",
                pagado: 1,
                idCongreso: idcongreso,
                valorCIBB: 0.00,
                formaPago: "",
                comprobantePago: "",
                opActSeleccionadas: "",
                grupoPertenece: 0,
                confirmarAsistencia:"-",
                checkedState: new Array(0).fill(false),
                opcionesActividades: [],
                opcionesActividadesGrupos: [],
                opcionesGrupo: [],
                aceptaTerminos: false,
                aceptaAvisoTraDatos: false
            },
            isLoading: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleCheckGroup = this.handleCheckGroup.bind(this);
        this.handleCheckGroupRadio = this.handleCheckGroupRadio.bind(this);
        this.getDatosEspol = this.getDatosEspol.bind(this);
        this.getDatosBienestar = this.getDatosBienestar.bind(this);
        this.getCiudades = this.getCiudades.bind(this);
        this.setNomPais = this.setNomPais.bind(this);
        this.setNomCiudad = this.setNomCiudad.bind(this);
        this.setCibbValor = this.setCibbValor.bind(this);
        this.esGraduadoPregrado = this.esGraduadoPregrado.bind(this);
        this.esGraduadoPostgrado = this.esGraduadoPostgrado.bind(this);
        this.esEstudiantePostgrado = this.esEstudiantePostgrado.bind(this);
        this.setModoInformadoDet = this.setModoInformadoDet.bind(this);
        this.setTipoInstitucionDet = this.setTipoInstitucionDet.bind(this);
        this.setTipoParticipanteDet = this.setTipoParticipanteDet.bind(this);
        this.setTipoEstudianteDet = this.setTipoEstudianteDet.bind(this);
        this.setTipoParticipacionDet = this.setTipoParticipacionDet.bind(this);
        this.setEsEspolDet = this.setEsEspolDet.bind(this);
        this.setEsPostgradoDet = this.setEsPostgradoDet.bind(this);
        this.getCelularFromWsAlumni = this.getCelularFromWsAlumni.bind(this);
        this.handleRecaptchaChange = this.handleRecaptchaChange.bind(this);
        this.formatDateString = this.formatDateString.bind(this);
        this.getDatosConsultaPersona = this.getDatosConsultaPersona.bind(this);
        this.showTermsTratamiento = this.showTermsTratamiento.bind(this);
    }

    handleRecaptchaChange(token) {
        this.setState({
            recaptchaToken: token
        })
    };

    handleCheck(event) {
        var updatedList = [...this.state.datosFormulario.checkedState];
        if (event.target.checked) {
            updatedList = [...this.state.datosFormulario.checkedState, event.target.value];
        } else {
            let index = this.state.datosFormulario.checkedState.indexOf(event.target.value);
            if (index != -1) {
                updatedList.splice(this.state.datosFormulario.checkedState.indexOf(event.target.value), 1);
            }
        }
        var dto = this.state.datosFormulario;
        //setChecked(updatedList);
        dto["checkedState"] = updatedList;
        console.log(updatedList);
        this.setState({ datosFormulario: dto });
        //console.log(this.state.datosFormulario.checkedState)
    };

    handleCheckGroup(event) {
        const clickedCheckbox = event.target;
        const checkboxesWithName = document.querySelectorAll(`input[name="${clickedCheckbox.name}"]`);
        //console.log(checkboxesWithName)
        checkboxesWithName.forEach(cb => {
            if (cb !== clickedCheckbox) {
                if (cb.checked) {
                    cb.checked = false;
                    console.log(cb)
                    this.handleCheck({ target: cb }); // Call handleCheck for unchecked checkboxes
                }             
            }
        });
        this.handleCheck(event); // Call handleCheck for the clicked checkbox
    }

    handleCheckGroupRadio(event) {
        const clickedCheckbox = event.target;
        const checkboxesWithName = document.querySelectorAll(`input[name="${clickedCheckbox.name}"]`);
        //console.log(checkboxesWithName)
        checkboxesWithName.forEach(cb => {
            if (cb !== clickedCheckbox) {
                cb.checked = false;
                console.log(cb)
                this.handleCheck({ target: cb }); // Call handleCheck for unchecked checkboxes
            }
        });
        this.handleCheck(event); // Call handleCheck for the clicked checkbox
    }

    expresiones = {
        cedula: /^\d{10}$/, //10 numeros
        fecha1: /^\d{4}-(0[1-9]|1[012])-\d{2}/, //Fecha formato yyyy-mm-dd
        usuario: /^[a-zA-Z0-9_-]{5,14}$/, // Letras, numeros, guion y guion_bajo
        pasaporte: /^[a-zA-Z0-9_-]{5,14}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,50}$/, // Letras y espacios, pueden llevar acentos.
        nombreinstitucion: /^[a-zA-ZÀ-ÿ\s]{1,255}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        correo: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        telefono: /^\d{7,14}$/ // 7 a 14 numeros.
    }


    getDatosEspol(ced) {
        //console.log("getDatosEspol", ced);
        //cargar formulario con datos de la API
        var dto = this.state.datosFormulario;
        dto["celular"] = "";
        try {
            this.setState({ isLoading: true });
            fetch("https://wsalumni.espol.edu.ec/api/Informacion/GetIdPersona/" + ced)
                .then(response => response.json())
                .then(responsejson => {
                    //console.log(responsejson); 
                    this.setState({ isLoading: false });
                    /*var dto = this.state.datosFormulario;*/
                    var datosgrado = responsejson.data["tdatosalumni"];
                    if (datosgrado !== null) {
                        //console.log("Sí es de ESPOL");
                        /*
                        dto["esEspol"] = "S";
                        dto["esEspolDet"] = "Sí";
                        dto["nombres"] = datosgrado.nombres;
                        dto["apellidos"] = datosgrado.apellidos;
                        dto["tipoInstitucion"] = "U";
                        dto["tipoInstitucionDet"] = "Universidad";
                        document.getElementById("universidad").checked = true;
                        dto["nombreInstitucion"] = "Escuela Superior Politécnica del Litoral";
                        dto["email"] = datosgrado.email;
                        */
                        dto["celular"] = datosgrado.codarea + datosgrado.telefonocelular;
                        //chequear si es estudiante de pregrado
                        //console.log(datosgrado.nombrecarrera);
                        //console.log(datosgrado.fechagraduacion);
                        //console.log(datosgrado.nombrecarrera !== null);
                        //console.log(datosgrado.fechagraduacion === null);
                        /*
                        if (datosgrado.nombrecarrera !== null && datosgrado.fechagraduacion === null) {

                            //console.log("entra a pregrado");

                            //console.log(datosgrado.nombrecarrera);
                            dto["tipoParticipante"] = "E";
                            dto["tipoParticipanteDet"] = "Estudiante";
                            document.getElementById("estudiante").checked = true;
                            dto["tipoEstudiante"] = "B";
                            dto["tipoEstudianteDet"] = "Pregrado";
                            document.getElementById("pregrado").checked = true;
                        }
                        //chequear si es estudiante de postgrado
                        else {
                            if (this.esEstudiantePostgrado(ced)) {
                                //console.log("Sí es estudiante de postgrado");
                                dto["tipoParticipante"] = "E";
                                dto["tipoParticipanteDet"] = "Estudiante";
                                document.getElementById("estudiante").checked = true;
                                dto["tipoEstudiante"] = "A";
                                dto["tipoEstudianteDet"] = "Postgrado";
                                dto["esPostgrado"] = "S";
                                document.getElementById("postgrado").checked = true;
                            }
                            //chequear si es graduado de pregrado o graduado de postgrado
                            else {
                                if ((datosgrado.nombrecarrera !== null && datosgrado.fechagraduacion !== null) || this.esGraduadoPostgrado(ced)) {
                                    //console.log(datosgrado.nombrecarrera);
                                    dto["tipoParticipante"] = "P";
                                    dto["tipoParticipanteDet"] = "Profesional";
                                    document.getElementById("profesional").checked = true;
                                }
                            }
                        }
                        */
                        this.setState({ datosFormulario: dto });
                        //console.log(this.state.datosFormulario);
                    }
                }).catch(error =>  {
                    console.log("Error: ", error);
                    this.setState({ isLoading: false });
                });
        }
        
        catch (error) {
            console.log("Error: ", error);
            this.setState({ isLoading: false });
        };
    }

    getDatosConsultaPersona(ced) {
        var dto = this.state.datosFormulario;
        dto["esEspol"] = "N";
        dto["esEspolDet"] = "No";
        dto["nombres"] = "";
        dto["apellidos"] = "";
        dto["tipoInstitucion"] = "";
        dto["tipoInstitucionDet"] = "";
        dto["nombreInstitucion"] = "";
        dto["email"] = "";
        dto["tipoParticipante"] = "";
        dto["tipoParticipanteDet"] = "";
        document.getElementById("grupoPertenece").value = "6";
        dto["grupoPertenece"] = "6";
        try {
            this.setState({ isLoading: true });
            fetch("https://wsarchivos.espol.edu.ec/api/Consultas/Persona/" + ced)
                .then(response => response.json())
                .then(responsejson => {
                    //console.log(responsejson); 
                    this.setState({ isLoading: false });
                    
                    var datosConsulta = responsejson[0];
                    if (datosConsulta !== null) {
                        //console.log("Sí es de ESPOL");
                        dto["nombres"] = datosConsulta.nombres;
                        dto["apellidos"] = datosConsulta.apellidos;
                        if (datosConsulta.correo == null || !datosConsulta.correo.includes("espol.edu.ec")) {
                            console.log("No espol");
                            this.setState({ datosFormulario: dto, isLoading: false });
                            return
                        }
                        console.log("Si espol");
                        dto["esEspol"] = "S";
                        dto["esEspolDet"] = "Sí";
                        dto["tipoInstitucion"] = "U";
                        dto["tipoInstitucionDet"] = "Universidad";
                        document.getElementById("universidad").checked = true;
                        dto["nombreInstitucion"] = "Escuela Superior Politécnica del Litoral";
                        dto["email"] = datosConsulta.correo;
                        //dto["celular"] = datosgrado.codarea + datosConsulta.telefonocelular;
                        //chequear si es estudiante de pregrado
                        //console.log(datosgrado.nombrecarrera);
                        //console.log(datosgrado.fechagraduacion);
                        //console.log(datosgrado.nombrecarrera !== null);
                        //console.log(datosgrado.fechagraduacion === null);
                        if (datosConsulta["idUnidadAcademica"] != null) {
                            dto["tipoParticipante"] = "P";
                            dto["tipoParticipanteDet"] = "Profesional";
                            document.getElementById("profesional").checked = true;
                            if (datosConsulta["unidadContratoDocencia"] == "FACULTAD DE CIENCIAS NATURALES Y MATEMÁTICAS") {
                                document.getElementById("grupoPertenece").value = "3";
                                dto["grupoPertenece"] = "3";
                            }
                            else {
                                document.getElementById("grupoPertenece").value = "4";
                                dto["grupoPertenece"] = "4";
                            }
                        }
                        else if (datosConsulta["rolesPostgrado"]?.includes("estudiantePostgradoGraduado")) {
                            dto["tipoParticipante"] = "P";
                            dto["tipoParticipanteDet"] = "Profesional";
                            document.getElementById("grupoPertenece").value = "5";
                            dto["grupoPertenece"] = "5";
                        }
                        else if (datosConsulta["rolesPostgrado"]?.includes("estudiantePostgrado")) {
                            dto["tipoParticipante"] = "E";
                            dto["tipoParticipanteDet"] = "Estudiante";
                            document.getElementById("estudiante").checked = true;
                            dto["tipoEstudiante"] = "A";
                            dto["tipoEstudianteDet"] = "Postgrado";
                            dto["esPostgrado"] = "S";
                            setTimeout(() => { document.getElementById("postgrado").checked = true }, 500);
                            //document.getElementById("postgrado").checked = true;
                            document.getElementById("grupoPertenece").value = "2";
                            dto["grupoPertenece"] = "2";
                        }
                        else if (datosConsulta["rolesGrado"]?.includes("Alumni")) {
                            dto["tipoParticipante"] = "P";
                            dto["tipoParticipanteDet"] = "Profesional";
                            document.getElementById("grupoPertenece").value = "5";
                            dto["grupoPertenece"] = "5";
                        }
                        else if (datosConsulta["rolesGrado"]?.includes("Activo")) {
                            dto["tipoParticipante"] = "E";
                            dto["tipoParticipanteDet"] = "Estudiante";
                            document.getElementById("estudiante").checked = true;
                            dto["tipoEstudiante"] = "B";
                            dto["tipoEstudianteDet"] = "Pregrado";
                            setTimeout(() => { document.getElementById("pregrado").checked = true }, 500);
                            //document.getElementById("pregrado").checked = true;
                            var programaGrado = datosConsulta["programaGrado"].filter(c => c["estado"] == "Activo")[0];
                            if (programaGrado["coddivision"] == "CI"
                                && programaGrado["codcarrera"] == "002"
                                && programaGrado["codespecializ"] == "  ")
                            {
                                document.getElementById("grupoPertenece").value = "1";
                                dto["grupoPertenece"] = "1";
                            }
                            else {
                                document.getElementById("grupoPertenece").value = "2";
                                dto["grupoPertenece"] = "2";
                            }
                        }
                        else {
                            document.getElementById("grupoPertenece").value = "6";
                            dto["grupoPertenece"] = "6";
                        }

                        this.setState({ datosFormulario: dto });
                        //console.log(this.state.datosFormulario);
                    }
                }).catch(error => {
                    document.getElementById("grupoPertenece").value = "6";
                    dto["grupoPertenece"] = "6";
                    console.log("Error: ", error);
                    this.setState({ datosFormulario: dto, isLoading: false });
                });
        }

        catch (error) {
            document.getElementById("grupoPertenece").value = "6";
            dto["grupoPertenece"] = "6";
            console.log("Error: ", error);
            this.setState({ datosFormulario: dto, isLoading: false });
        };
    }

    getDatosBienestar(ced) {
        try {
            this.setState({ isLoading: true });
            //fetch("https://wssaac.espol.edu.ec/bienestar/api/Informacion/GetEstudianteAcadByIdentificacion/" + ced)
            fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/GetDatosBienestarAPI/" + ced)
                .then(response => response.json())
                .then(responsejson => {
                    this.setState({ isLoading: false });
                    var dto = this.state.datosFormulario;
                    var datosbienestar = responsejson["data"];
                    if (datosbienestar !== null) {
                        dto["esEspol"] = "S";
                        dto["esEspolDet"] = "Sí";
                        dto["nombres"] = datosbienestar.nombres;
                        dto["apellidos"] = datosbienestar.apellidos;
                        dto["institucion"] = "U";
                        dto["institucionDet"] = "Universidad";
                        document.getElementById("universidad").checked = true;
                        dto["nombreInstitucion"] = "Escuela Superior Politécnica del Litoral";
                        dto["email"] = datosbienestar.email;
                        //obtener celular
                        dto["celular"] = this.getCelularFromWsAlumni(ced);
                        //chequear si es graduado de pregrado o graduado de postgrado - PROFESIONAL
                        if (this.esGraduadoPregrado(ced) || this.esGraduadoPostgrado(ced)) {
                            dto["tipoParticipante"] = "P";
                            dto["tipoParticipanteDet"] = "Profesional";
                            document.getElementById("profesional").checked = true;
                        }
                        else {
                            dto["tipoParticipante"] = "E";
                            dto["tipoParticipanteDet"] = "Estudiante";
                            document.getElementById("estudiante").checked = true;
                            //chequear si es estudiante de postgrado
                            if (this.esEstudiantePostgrado(ced)) {
                                dto["tipoEstudiante"] = "A";
                                dto["tipoEstudianteDet"] = "Postgrado";
                                dto["esPostgrado"] = "S";
                                document.getElementById("postgrado").checked = true;
                            }
                            else {
                                //ya en este caso se llena form como estudiante de pregrado
                                dto["tipoEstudiante"] = "B";
                                dto["tipoEstudianteDet"] = "Pregrado";
                                document.getElementById("pregrado").checked = true;
                            }
                        }

                        this.setState({ datosFormulario: dto });
                    }

                });
        }

        catch (error) {
            console.log("Error: ", error);
            this.setState({ isLoading: false });
        };
    }

    componentDidMount() {
        this.getCongresoActual();
        //this.getPaises();
        //this.getOpcionesActividades();
        //this.getOpcionesGrupo();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.evento != undefined && prevState.evento !== this.state.evento) {
            //console.log(prevState.evento);
            //console.log(this.state.evento);
            this.getOpcionesActividades();
            this.getOpcionesGrupo();
        }
        if (this.state.datosFormulario.opcionesActividades.length > 0 &&
            this.state.datosFormulario.opcionesGrupo.length > 0 &&
            this.state.datosFormulario.paises.length === 0) {
            this.getPaises();
        }
    }

    getCongresoActual() {
        fetch(process.env.REACT_APP_URI_SERVER + "api/TblCongresoes/GetQuimicaActual")
            .then(response => response.json())
            .then(response => {
                //console.log(response);
                var dto = this.state.datosFormulario;
                var idcongreso = response["idcongreso"];
                dto["idCongreso"] = idcongreso;
                var inicioInscripcion = Date.parse(response["fechainicioinscripcion"]);
                var finInscripcion = Date.parse(response["fechafininscripcion"]);
                var fechaActual = Date.now();
                var listTarifas = response["tarifas"];
                var valorInternos = listTarifas.filter(t => t["esespol"] == "S")[0]["precio"];
                var valorExternos = listTarifas.filter(t => t["esespol"] == "N")[0]["precio"];
                console.log(listTarifas, valorInternos, valorExternos);
                //var aceptaRegistro = inicioInscripcion <= fechaActual && fechaActual <= finInscripcion;
                //console.log(aceptaRegistro);
                this.setState({
                    valorExternos: valorExternos,
                    valorInternos: valorInternos,
                    titulo: response["descripcion"],
                    evento: idcongreso,
                    anioEvento: response["anio"],
                    isDespuesRegInicio: inicioInscripcion <= fechaActual,
                    fechaInicioInsc: String(response["fechainicioinscripcion"]).split("T")[0],
                    isAntesRegFin: fechaActual <= finInscripcion,
                    fechaFinInsc: String(response["fechafininscripcion"]).split("T")[0],
                    datosFormulario: dto
                });
            })
            .catch(error => {
                console.log("Error: ", error);
            })
    }

    getOpcionesGrupo() {
        //console.log("Llamando funcion get paises");
        fetch(`${process.env.REACT_APP_URI_SERVER}api/Opcion/GetOpcionesGrupo/` + this.state.evento)
            .then(response => response.json())
            .then(responsejson => {
                var dto = this.state.datosFormulario;
                dto["opcionesGrupo"] = responsejson;
                dto["valorCIBB"] = this.state.valorInternos;
                if (responsejson.length > 0)
                    dto["grupoPertenece"] = responsejson[0].indice;
                else
                    dto["grupoPertenece"] = 0;
                this.setState({ datosFormulario: dto });
                //console.log(this.state.datosFormulario.paises);
            });
    }

    capitalizeFirstLetter(s) {
        return s && String(s[0]).toUpperCase() + String(s).slice(1);
    }

    getOpcionesActividades() {
        //console.log("Llamando funcion get paises");
        fetch(`${process.env.REACT_APP_URI_SERVER}api/Opcion/GetOpcionesActividades/` + this.state.evento)
            .then(response => response.json())
            .then(responsejson => {
                var dto = this.state.datosFormulario;
                var responseWithDate = responsejson.map(act => {
                    let newGrupos = act.grupos.map(g => {
                        let datesGrupo = g.fecha.split("/").map(fs => this.extractDateFromText(fs))
                        return { ...g, fechasDate: datesGrupo }
                    })
                    return { ...act, grupos: newGrupos, idActSameStart: "" }
                })
                //console.log(responseWithDate);

                //let grupoFecha = { ...Object.groupBy(responseWithDate, ({ grupos }) => this.capitalizeFirstLetter(grupos[0].fechasDate[0].startDate.toLocaleDateString("es-EC", options))) }
                let grupoFecha = { ...Object.groupBy(responseWithDate, ({ grupos }) => new Date(grupos[0].fechasDate[0].startDate).setHours(0, 0, 0, 0)) }

                console.log(grupoFecha)


                const grouped = {};

                responseWithDate.forEach(obj => {
                    if (!obj.grupos || obj.grupos.length === 0) return; // Skip if no grupos

                    obj.grupos.forEach(grupo => {
                        grupo.fechasDate.forEach(fechas => {
                            const dateKey = new Date(fechas.startDate).setHours(0, 0, 0, 0)

                            if (!grouped[dateKey]) {
                                grouped[dateKey] = [];
                            }

                            grouped[dateKey].push(obj);
                        })

                    });
                });

                console.log(grouped)

                let actividadesYaSelect = [];

                let grupoFechaActividades = Object.entries(grouped).map(([key, value]) => {
                    let opcionesList = value.filter((act, index, array) => array.findIndex(v => v.indice == act.indice) == index)
                    let listFechas = opcionesList.flatMap(opc => opc.grupos.flatMap(g => g.fechasDate.map(fd => fd.startDate.getTime())))
                    let listFechasConflict = listFechas.filter((f, index, array) => array.findIndex(o => o == f) != index)
                    console.log(listFechasConflict)
                    opcionesList = opcionesList.map(o => {
                        let listDates = o.grupos.flatMap(g => g.fechasDate.flatMap(fd => fd.startDate.getTime()))
                        let idSameHour = listDates.some(d => listFechasConflict.includes(d)) ? listDates.filter(d => listFechasConflict.includes(d))[0].toString() : ""
                        return { ...o, idActSameStart: idSameHour}
                    })

                    let numFecha = Number(key);

                    let opcionesActividadesList = opcionesList.sort((a, b) => {
                        let gruposa = a.grupos.map(g => {
                            let newFechas = g.fechasDate.filter(f => new Date(f.startDate).setHours(0, 0, 0, 0) == numFecha)
                            return { ...g, fechasDate: newFechas }
                        })
                        let gruposb = b.grupos.map(g => {
                            let newFechas = g.fechasDate.filter(f => new Date(f.startDate).setHours(0, 0, 0, 0) == numFecha)
                            return { ...g, fechasDate: newFechas }
                        })
                        let gruposaq = a.grupos.filter(g => new Date(g.fechasDate.filter(f => new Date(f.startDate).setHours(0, 0, 0, 0) == numFecha)[0]?.startDate).setHours(0, 0, 0, 0) == numFecha)
                        let gruposbq = b.grupos.filter(g => new Date(g.fechasDate.filter(f => new Date(f.startDate).setHours(0, 0, 0, 0) == numFecha)[0]?.startDate).setHours(0, 0, 0, 0) == numFecha)
                        //console.log(gruposa, gruposb)
                        return (gruposa[0].fechasDate[0]?.startDate - gruposb[0].fechasDate[0]?.startDate)
                    });

                    actividadesYaSelect = [...actividadesYaSelect, ...opcionesActividadesList.map(({ indice, titular, fecha, adicional, grupos, idActSameStart }, index) => {
                        let result;
                        if ((!(titular.includes("Visita técnica") || false) && grupos.length <= 1) && (!idActSameStart && grupos.length <= 1)  ) {
                            console.log(indice);
                            result = indice;
                        }
                        else {
                            result = null;
                        }
                        return result;
                    })]

                    return {
                        numFecha: numFecha,
                        strFecha: this.capitalizeFirstLetter((new Date(Number(key))).toLocaleDateString("es-EC", this.state.options)),
                        opcionesActividadesList: opcionesActividadesList,
                }});

                let listIndicesActYaSelect = [...new Set(actividadesYaSelect.filter(act => act != null))].map(ind => String(ind));

                console.log(grupoFechaActividades)
                console.log(actividadesYaSelect)

                dto["opcionesActividades"] = responseWithDate;
                dto["opcionesActividadesGrupos"] = grupoFechaActividades;
                dto["checkedState"] = [...new Array(responsejson.length).fill(false), ...listIndicesActYaSelect];
                this.setState({ datosFormulario: dto });

                //console.log(this.state.datosFormulario.paises);
            });
    }
    getPaises() {
        //console.log("Llamando funcion get paises");
        fetch("https://ws.espol.edu.ec/rest/api/Pais/getconciudad")
            .then(response => response.json())
            .then(responsejson => {
                var dto = this.state.datosFormulario;
                dto["paises"] = responsejson;
                this.setState({ datosFormulario: dto });
                //console.log(this.state.datosFormulario.paises);
            });
    }


    getCiudades(idPais) {
        var jsonLengthCountries = this.state.datosFormulario.paises.length;
        var dto = this.state.datosFormulario;

        for (let i = 0; i < jsonLengthCountries; i++) {
            if (dto.paises[i].siIdPais === idPais) {
                dto.ciudades = dto.paises[i].listCanton;
            }
        }

        this.setState({ datosFormulario: dto });

    }


    setNomPais(idPais) {
        var dto = this.state.datosFormulario;
        var lengthCountries = dto.paises.length;
        var puesto = 0;

        while (dto.paises[puesto].siIdPais !== idPais && puesto < lengthCountries) {
            puesto++;
        }
        dto.paisNom = this.state.datosFormulario.paises[puesto].strNombre;
        this.setState({ datosFormulario: dto });
    }



    setNomCiudad(idCiudad) {
        var dto = this.state.datosFormulario;
        var lengthCities = dto.ciudades.length;
        var puesto = 0;
        while (dto.ciudades[puesto].siIdCanton !== idCiudad && puesto < lengthCities) {
            puesto++;
        }
        dto.ciudadNom = this.state.datosFormulario.ciudades[puesto].strNombreCanton;
        this.setState({ datosFormulario: dto});
    }

    setTipoInstitucionDet() {
        var dto = this.state.datosFormulario;
        if (dto.tipoInstitucion === "E") {
            dto.tipoInstitucionDet = "Empresa";
            if (dto.nombreInstitucion == "No aplica") {
                dto.nombreInstitucion = "";
            }
        }
        if (dto.tipoInstitucion === "U") {
            dto.tipoInstitucionDet = "Universidad";
            if (dto.nombreInstitucion == "No aplica") {
                dto.nombreInstitucion = "";
            }
        }
        if (dto.tipoInstitucion === "O") {
            dto.tipoInstitucionDet = "Otro";
            if (!dto.nombreInstitucion) {
                dto.nombreInstitucion = "No aplica";
            }
        }

        this.setState({ datosFormulario: dto });
    }

    setTipoParticipanteDet() {
        var dto = this.state.datosFormulario;
        if (dto.tipoParticipante === "P") {
            dto.tipoParticipanteDet = "Profesional";
        }
        if (dto.tipoParticipante === "E") {
            dto.tipoParticipanteDet = "Estudiante";
        }

        this.setState({ datosFormulario: dto });
    }

    setTipoEstudianteDet() {
        var dto = this.state.datosFormulario;
        if (dto.tipoEstudiante === "B") {
            dto.tipoEstudianteDet = "Pregrado";
        }
        if (dto.tipoEstudiante === "A") {
            dto.tipoEstudianteDet = "Postgrado";
        }

        this.setState({ datosFormulario: dto });
    }

    setTipoParticipacionDet() {
        var dto = this.state.datosFormulario;
        if (dto.tipoParticipacion === "O") {
            dto.tipoParticipacionDet = "Oral";
        }
        if (dto.tipoParticipacion === "P") {
            dto.tipoParticipacionDet = "Audiocartel";
        }
        if (dto.tipoParticipacion === "A") {
            dto.tipoParticipacionDet = "Asistente";
        }
        
        this.setState({ datosFormulario: dto });
    }


    setModoInformadoDet() {
        var dto = this.state.datosFormulario;
        if (dto.modoInformado === "R") {
            dto.modoInformadoDet = "Redes Sociales";
        }
        if (dto.modoInformado === "P") {
            dto.modoInformadoDet = "Página Web";
        }
        if (dto.modoInformado === "C") {
            dto.modoInformadoDet = "Correo Electrónico";
        }
        if (dto.modoInformado === "O") {
            dto.modoInformadoDet = "Otros";
        }
        this.setState({ datosFormulario: dto });
    }

    setEsEspolDet() {
        var dto = this.state.datosFormulario;
        if (dto.esEspol === "S") {
            dto.esEspolDet = "Sí";
        }
        if (dto.esEspol === "N") {
            dto.esEspolDet = "No";
        }

        this.setState({ datosFormulario: dto });
    }

    setEsPostgradoDet() {
        var dto = this.state.datosFormulario;
        if (dto.esPostgrado === "S") {
            dto.esPostgradoDet = "Sí";
        }
        if (dto.esPostgrado === "N") {
            dto.esPostgradoDet = "No";
        }

        this.setState({ datosFormulario: dto });
    }

    

    setCibbValor() {
        var fechaCorte = new Date(2022, 5, 30);
        var dto = this.state.datosFormulario;
        if (new Date() > fechaCorte) {
            if (dto.esEspol === "S") {
                if (dto.tipoParticipante === "P" || dto.tipoestudiante === "A") {
                    dto.valorCIBB = 135.00;
                }
                else {
                    dto.valorCIBB = 67.50;
                }                
            }
            else {
                if (dto.tipoParticipante === "P" || dto.tipoestudiante === "A") {
                    dto.valorCIBB = 150.00;
                }
                else {
                    dto.valorCIBB = 75.00;
                }
            }

        }
        else {
            if (dto.esEspol === "S") {
                if (dto.tipoParticipante === "P" || dto.tipoestudiante === "A") {
                    dto.valorCIBB = 90.00;
                }
                else {
                    dto.valorCIBB = 45.00;
                }
            }
            else {
                if (dto.tipoParticipante === "P" || dto.tipoestudiante === "A") {
                    dto.valorCIBB = 100.00;
                }
                else {
                    dto.valorCIBB = 50.00;
                }
            }
        }
        this.setState({ datosFormulario: dto });
    }


    getCelularFromWsAlumni(ced) {
        try {
            this.setState({ isLoading: true });
            fetch("https://wsalumni.espol.edu.ec/api/Informacion/GetIdPersona/" + ced)
                .then(response => response.json())
                .then(responsejson => {          
                    this.setState({ isLoading: false });
                    var datosgrado = responsejson["tdatosalumni"];
                    var numCelular = null;
                    if (datosgrado !== null) {
                        numCelular = datosgrado.codarea + datosgrado.telefonocelular;
                    }
                    //console.log("El número celular de " + ced + " es " + numCelular);
                    return numCelular;
                });
        }

        catch (error) {
            console.log("Error: ", error);
            this.setState({ isLoading: false });
        }
    }


    esGraduadoPregrado(ced) {
        try {
            this.setState({ isLoading: true });
            fetch("https://wsalumni.espol.edu.ec/api/Informacion/GetIdPersona/" + ced)
                .then(response => response.json())
                .then(responsejson => {
                    this.setState({ isLoading: false });
                    var datosgrado = responsejson["tdatosalumni"];
                    if (datosgrado !== null) {
                        //console.log("Persona con cédula " + ced + " es graduado de pregrado.");
                        return true;
                    }
                    else {
                        //console.log("Persona con cédula " + ced + " no es graduado de pregrado.");
                        return false;
                    }
                })
        }

        catch (error) {
            console.log("Error: ", error);
            this.setState({ isLoading: false });
        }
    }


    esGraduadoPostgrado(ced) {
        //console.log("Llamando a la funcion esGraduadoPostgrado");
        try {
            this.setState({ isLoading: true });
            fetch('api/Postgrado/IsPostgrado' + ced)
                //.then(res => res.json())
                .then(resjson => {
                    //console.log("Esto es lo que me devuelve la funcion esGraduadoPostgrado");
                    //console.log(resjson);
                    this.setState({ isLoading: false});
                    if (resjson.strEstado === "S") {
                        if (resjson.esGraduadoPost) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                })
        }

        catch (error) {
            console.log("Error: ", error);
            this.setState({ isLoading: false });
        };
    }
    

    esEstudiantePostgrado(ced) {
        //console.log("Llamando a la funcion esEstudiantePostgrado");
        try {
            this.setState({ isLoading: true });
            fetch('Postgrado/IsPostgrado/' + ced)
                //.then(res => res.json())
                .then(resjson => {
                    //console.log("Esto es lo que me devuelve la funcion esEstudiantePostgrado");
                    //console.log(resjson);
                    this.setState({ isLoading: false });
                    if (resjson.strEstado === "S") {
                        if (resjson.esEstudiantePost) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                }
                );
        }

        catch (error) {
            console.log("Error: ", error);
            this.setState({ isLoading: false });
        };        
        
    }


    handleChange(e) {
        //console.log("propery: ", e.target.name);
        //console.log("value: ", e.target.value);
        var dto = this.state.datosFormulario;
        dto[e.target.name] = e.target.value;
        

        
        if (e.target.id === "cedula" && e.target.value.length === 10) {
            //console.log("en if de cedula");
            var cedula = this.state.datosFormulario.numeroIdentificacion;
            this.getDatosConsultaPersona(cedula);
            this.getDatosEspol(cedula);
            dto["paisId"] = null;
            dto["paisNom"] = "";
            dto["ciudadId"] = "";
            dto["ciudadNom"] = "";
            dto["pagado"] = 1;
        }


        if (e.target.name === "paisId") {
            this.getCiudades(Number(e.target.value));
            this.setNomPais(Number(e.target.value));
            fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/Registrado/` +
                this.state.datosFormulario.numeroIdentificacion + "/" +
                e.target.value + "/" +
                this.state.datosFormulario.idCongreso)
                .then(res => res.json())
                .then(data => {
                    var dto = this.state.datosFormulario;
                    var pagadoResult = data.tblCibbRegistro.pagado;
                    dto["pagado"] = pagadoResult;
                    console.log(data.tblCibbRegistro.rutaComprobante)
                    let isregistrado = pagadoResult == 2 || (pagadoResult==1 && data.tblCibbRegistro.rutaComprobante!=null)
                    this.setState({ isRegistrado: isregistrado, datosFormulario: dto });
                    //console.log(this.state.datosFormulario.pagado);
                })
                .catch(e => {
                    console.log(e);
                    var dto = this.state.datosFormulario;
                    dto["pagado"] = 1;
                    this.setState({ isRegistrado: false, datosFormulario: dto });
                    //console.log(this.state.datosFormulario.pagado);
                })
        }

        if (e.target.name === "grupoPertenece") {      
            if (e.target.value == "6") {
                dto["valorCIBB"] = this.state.valorExternos;
            } else {
                dto["valorCIBB"] = this.state.valorInternos;
            }            
        }

        if (e.target.name === "ciudadId") {
            this.setNomCiudad(Number(e.target.value));
        }

        if (e.target.name === "tipoInstitucion") {
            //console.log(e.target.value)
            this.setTipoInstitucionDet();
        }

        if (e.target.name === "tipoParticipante") {
            //console.log(e.target.value)
            this.setTipoParticipanteDet();
        }

        if (e.target.name === "tipoEstudiante") {
            //console.log(e.target.value)
            this.setTipoEstudianteDet();
        }

        if (e.target.name === "tipoParticipacion") {
            //console.log(e.target.value)
            this.setTipoParticipacionDet();
        }

        if (e.target.name === "aceptaAvisoTraDatos") {
            dto.aceptaAvisoTraDatos = e.target.checked;
        }

        if (e.target.name === "aceptaTerminos") {
            dto.aceptaTerminos = e.target.checked;
        }
        //console.log(dto);
        this.setState({ datosFormulario: dto });
        //if (e.target.name === "modoInformado") {
        //    //console.log(e.target.value)
        //    this.setModoInformadoDet();
        //}

    }


    uploadFile = (id) => {
        //creating form data object and append file into that form data
        let formData = new FormData();
        formData.append("file", document.getElementById("presentacion").files[0]);
        formData.append("idCongresoRegistro", id);
        formData.append("Pais", this.state.datosFormulario.paisNom);
        formData.append("Ciudad", this.state.datosFormulario.ciudadNom);
        formData.append("Instituciondet", this.state.datosFormulario.tipoInstitucionDet);
        formData.append("Tipoparticipantedet", this.state.datosFormulario.tipoParticipanteDet);
        formData.append("Tipoestudiantedet", this.state.datosFormulario.tipoEstudianteDet);
        formData.append("Participaciondet", this.state.datosFormulario.tipoParticipacionDet);
        formData.append("Modoinformadodet", this.state.datosFormulario.modoInformadoDet);
        this.setState({ isLoading: true });
        fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/SubirDocumento`, {

        //con dirección de prueba del backend
        //fetch("http://192.168.253.6:8091/api/TblCibbRegistroes/SubirDocumento", {

        //fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/SubirDocumento", {
            method: "POST",
            //headers: {
            //    'Content-Type': 'multipart/form-data'
            //},
            body: formData
        }).then(res => {
            this.setState({ isLoading: false });
        })
            .catch((error) => {
                console.log(error);
                this.setState({ isLoading: false });
            });
    }



    uploadComprobante = async (id) => {
        //creating form data object and append file into that form data
        //console.log("Entre a subir comprobante");
        let formData = new FormData();
        formData.append("file", document.getElementById("comprobantePago").files[0]);
        formData.append("idRegistroCIBB", id);
        formData.append("pais", this.state.datosFormulario.paisNom);
        formData.append("ciudad", this.state.datosFormulario.ciudadNom);
        formData.append("institucionDet", this.state.datosFormulario.tipoInstitucionDet);
        formData.append("tipoParticipanteDet", this.state.datosFormulario.tipoParticipanteDet);
        formData.append("tipoEstudianteDet", this.state.datosFormulario.tipoEstudianteDet);
        formData.append("participacionDet", this.state.datosFormulario.tipoParticipacionDet);
        formData.append("modoInformadoDet", this.state.datosFormulario.modoInformadoDet);
        this.setState({ isLoading: true });
        await fetch(`${ process.env.REACT_APP_URI_SERVER }api/TblCibbRegistroes/SubirComprobante`, {
            method: "POST",
            //headers: {
            //    'Content-Type': 'multipart/form-data'
            //},
            body: formData
        }).then(res => {
            this.setState({ isLoading: false });
            //console.log(res);
            if (res.status == 200) {
                Swal.fire({
                    title: "¡Comprobante subido exitosamente!",
                    text: "Usted ha sido prerregistrado.",
                    icon: "success"
                }).then(
                    function () {
                        window.location.reload();
                    });
            } else {
                Swal.fire({
                    title: "¡El comprobante no se pudo guardar!",
                    text: "No se ha podido completar el registro. Vuelva a intertarlo más tarde.",
                    icon: "error"
                }).then(_ => {
                    window.grecaptcha.reset();
                    this.handleRecaptchaChange(null);
                });
            }
            
        })
            .catch((error) => {
                console.log(error);
                this.setState({ isLoading: false});
            });
    }


    validarFormulario = () => {
        //console.log("Lamando funcion validarFormulario");
        var dto = this.state.datosFormulario;
        var lista = this.state.datosFormulario.checkedState;
        var stringList = "";
        for (var i = 0; i < lista.length; i++) {
            if (lista[i] !== false) {
                stringList += lista[i] + ";";    
            }
        }
        dto["opActSeleccionadas"] = stringList;
        this.setState({ datosFormulario: dto });
        //console.log(dto);

        //if (!dto.aceptaTerminos) {
        //    Swal.fire({
        //        title: "Términos y condiciones del evento.",
        //        text: "Leer y aceptar los términos y condiciones.",
        //        icon: "error"
        //    })
        //}

        const maxSize = 20 * 1024 * 1024; // Maximum file size: 2MB

        if (
            (dto.tipoIdentificacion === "C" && !this.expresiones.cedula.test(this.state.datosFormulario.numeroIdentificacion)) ||
            (dto.tipoIdentificacion === "P" && !this.expresiones.pasaporte.test(this.state.datosFormulario.numeroIdentificacion)) ||
            !this.expresiones.nombre.test(this.state.datosFormulario.nombres) ||
            !this.expresiones.nombre.test(this.state.datosFormulario.apellidos) ||
            dto.paisId === "" ||
            dto.ciudadId === "" ||
            dto.tipoInstitucion === "" ||
            !this.expresiones.nombreinstitucion.test(this.state.datosFormulario.nombreInstitucion) ||
            dto.tipoParticipante === "" ||
            (dto.tipoParticipante === "E" && dto.tipoEstudiante === "") ||
            !this.expresiones.correo.test(this.state.datosFormulario.email) ||
            !this.expresiones.cedula.test(this.state.datosFormulario.celular) ||
            dto.tipoParticipacion === "" ||
            (dto.tipoParticipacion !== "A" && dto.presentacion === "") ||
            dto.modoInformado === "" || parseInt(dto.grupoPertenece) <= 0 || dto.confirmarAsistencia === ""
            || stringList === "" || (dto.formaPago === "" && dto.pagado != 2) || (dto.formaPago === "B" && document.getElementById("comprobantePago").files[0] == undefined)
        ) {
            
            return false
        }
        else if (dto.formaPago === "B" && document.getElementById("comprobantePago").files[0].size > maxSize) { // Check if file exceeds size limit
            alert('Archivo excede el límite de 20MB.');
            return false; // Abort if the file is too large
        }
        else { return true }
    }

    showTerms() {
        Swal.fire({
            html: TerminosCondicionesQuimicaString(),
            width: "80vw",
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
            showClass: {
                popup: `
                    animate__animated
                    animate__fadeInUp
                    animate__faster
                `
            },
            hideClass: {
                popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                `
            },
            confirmButtonText: `Aceptar`,
            confirmButtonColor: 'rgb(108, 87, 136)'
        }).then((result) => {
            if (result.isConfirmed) {
                var element = document.getElementById("aceptaTerminos");
                element.checked = true;
                element.setCustomValidity("");
                this.handleChange({ target: element })
            }
        })
    }

    showTermsTratamiento() {
        Swal.fire({
            html: TratamientoDatosQuimicaString(),
            width: "80vw",
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
            showClass: {
                popup: `
                    animate__animated
                    animate__fadeInUp
                    animate__faster
                `
            },
            hideClass: {
                popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                `
            },
            confirmButtonText: `Aceptar`,
            confirmButtonColor: 'rgb(108, 87, 136)'
        }).then((result) => {
            if (result.isConfirmed) {
                var element = document.getElementById("aceptaAvisoTraDatos");
                element.checked = true;
                element.setCustomValidity("");
                this.handleChange({ target: element})
            }
        })
    }

     async validarCupos() {
        var cuposValidos = true;
        await fetch(`${process.env.REACT_APP_URI_SERVER}api/Opcion/GetOpcionesActividades/` + this.state.evento)
            .then(response => response.json())
            .then(response => {
                //console.log(response);
                var actividadesCupo = response;
                var actividadesSeleccionadas = this.state.datosFormulario.opActSeleccionadas.split(";");
                actividadesSeleccionadas.forEach(act => {
                    if (act !== "") {
                        var grupo = act.split("_");
                        var grupoDatos;
                        if (grupo.length === 1) {
                            grupoDatos = actividadesCupo[parseInt(grupo[0]) - 1].grupos[0];
                        } else {
                            grupoDatos = actividadesCupo[parseInt(grupo[0]) - 1].grupos[parseInt(grupo[1])];       
                        }
                        if (grupoDatos.cupo !== 0 && grupoDatos.disponible <= 0) { cuposValidos = false; /*console.log(act);*/ }
                    }
                });
                if (!cuposValidos) {
                    var dto = this.state.datosFormulario;
                    dto["opcionesActividades"] = response;
                    this.setState({ datosFormulario: dto });
                }
                //return cuposValidos;
            })
            .catch(error => {
                console.log("Error: ", error);
                //return false;
            })
         
        return cuposValidos;
    }

    sortOptSelectedString(input) {
        return input
            .split(';') // 1. Turn the string into an array
            .sort((a, b) => {
                // 2. Extract the number before the "_" for comparison
                const numA = parseInt(a.split('_')[0], 10);
                const numB = parseInt(b.split('_')[0], 10);

                // 3. Compare as numbers (ascending)
                return numA - numB;
            })
            .join(';'); // 4. Join back into a string
    }

    onSubmit = async (e) => {
        //console.log(this.validarFormulario());
        e.preventDefault();
        if (!this.state.onProcess) {
         
            if (!this.state.recaptchaToken) {
                alert("No ha completado el reCAPTCHA.");
                return
            }

            this.setState({
                onProcess: true
            });

            var formularioValido = this.validarFormulario();
            var cuposDisponibles = false;
            if (formularioValido) {
                cuposDisponibles = await this.validarCupos();
            }
            //console.log("CUPOS DISPONIBLES:");
            //console.log(cuposDisponibles);
            if (formularioValido && cuposDisponibles && (this.state.isDespuesRegInicio && this.state.isAntesRegFin)) {
                //var estadoPagado;
                var idCibb;
                //console.log(this.state.datosFormulario);
                //con API local
                this.setState({ isLoading: true });
                await fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/Registrado/` +
                    this.state.datosFormulario.numeroIdentificacion + "/" +
                    this.state.datosFormulario.paisId + "/" +
                    this.state.datosFormulario.idCongreso)
                    .then(res => res.json())
                    .then(async data => {
                        this.setState({ isLoading: false });
                        //revisar si el participante ya está registrado
                        if (data.strEstado === "N") {
                            //crear registro
                            //e.preventDefault();
                            //this.setCibbValor();
                            const POST_CIBB = JSON.stringify({
                                "apellidos": this.state.datosFormulario.apellidos,
                                "nombres": this.state.datosFormulario.nombres,
                                "numeroidentificacion": this.state.datosFormulario.numeroIdentificacion,
                                "idpais": this.state.datosFormulario.paisId,
                                "pais": this.state.datosFormulario.paisNom,
                                "idcanton": this.state.datosFormulario.ciudadId,
                                "ciudad": this.state.datosFormulario.ciudadNom,
                                "tipoinstitucion": this.state.datosFormulario.tipoInstitucion,
                                "instituciondet": this.state.datosFormulario.tipoInstitucionDet,
                                "nombreinstitucion": this.state.datosFormulario.nombreInstitucion,
                                "tipoparticipante": this.state.datosFormulario.tipoParticipante,
                                "tipoparticipantedet": this.state.datosFormulario.tipoParticipanteDet,
                                "tipoestudiante": this.state.datosFormulario.tipoEstudiante,
                                "tipoestudiantedet": this.state.datosFormulario.tipoEstudianteDet,
                                "email": this.state.datosFormulario.email,
                                "celular": this.state.datosFormulario.celular,
                                "tipoparticipacion": this.state.datosFormulario.tipoParticipacion,
                                "participaciondet": this.state.datosFormulario.tipoParticipacionDet,
                                "rutapresentacion": this.state.datosFormulario.presentacion,
                                "modoinformado": this.state.datosFormulario.modoInformado,
                                "modoinformadodet": this.state.datosFormulario.modoInformadoDet,
                                "otromodoinformado": this.state.datosFormulario.otroModoInformado,
                                "esespol": this.state.datosFormulario.esEspol,
                                "fecharegistro": new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                "aniocongreso": this.state.anioEvento,//"2022", //TODO
                                "pagado": this.state.datosFormulario.pagado,
                                "idcongreso": this.state.datosFormulario.idCongreso,
                                "tipoasistencia": this.state.datosFormulario.tipoAsistencia,
                                "opactseleccionadas": this.sortOptSelectedString(this.state.datosFormulario.opActSeleccionadas),
                                "grupopertenece": this.state.datosFormulario.grupoPertenece,
                                "confirmarasistencia": this.state.datosFormulario.confirmarAsistencia,
                                "aceptaavisotradatos": this.state.datosFormulario.aceptaAvisoTraDatos ? "S" : "N",
                            });
                            //Dirección local del backend
                            this.setState({ isLoading: true });
                            await fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/Guardar`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'X-Recaptcha-Token': this.state.recaptchaToken },
                                body: POST_CIBB
                            })
                                .then(res => res.json())
                                .then(async data => {
                                    //console.log(data);
                                    //if (data.rutapresentacion !== null && data.rutapresentacion !== "") {
                                    //    this.uploadFile(data.idcongresoregistro);
                                    //}
                                    this.setState({ isLoading: false });
                                    Swal.fire({
                                        title: "¡Formulario Válido!",
                                        text: "Procesando prerregistro...",
                                        icon: "success"
                                    });
                                    if (this.state.datosFormulario.tipoParticipacion === "A" &&
                                        this.state.datosFormulario.formaPago === "T") {
                                        Swal.fire({
                                            title: "Redireccionando...",
                                            text: "Redireccionando a página de pago.",
                                            icon: "success"
                                        });
                                        //Crear transaccion
                                        this.setState({ isLoading: true });
                                        await fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/CrearTransaccionAPI`, {
                                            //con a dirección de prueba
                                            //fetch("http://192.168.253.6:8091/api/TblCibbRegistroes/CrearTransaccionAPI", {
                                            //fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/CrearTransaccionAPI", {                        
                                            method: 'POST',
                                            headers: { 'Content-Type': 'application/json' },
                                            body: JSON.stringify({
                                                "idcongresoregistro": data.idcongresoregistro,
                                                "apellidos": this.state.datosFormulario.apellidos,
                                                "nombres": this.state.datosFormulario.nombres,
                                                "numeroidentificacion": this.state.datosFormulario.numeroIdentificacion,
                                                "idpais": this.state.datosFormulario.paisId,
                                                "idcanton": this.state.datosFormulario.ciudadId,
                                                "tipoinstitucion": this.state.datosFormulario.tipoInstitucion,
                                                "nombreinstitucion": this.state.datosFormulario.nombreInstitucion,
                                                "tipoparticipante": this.state.datosFormulario.tipoParticipante,
                                                "tipoestudiante": this.state.datosFormulario.tipoEstudiante,
                                                "email": this.state.datosFormulario.email,
                                                "celular": this.state.datosFormulario.celular,
                                                "tipoparticipacion": this.state.datosFormulario.tipoParticipacion,
                                                "rutapresentacion": this.state.datosFormulario.presentacion,
                                                "modoinformado": this.state.datosFormulario.modoInformado,
                                                "otromodoinformado": this.state.datosFormulario.otroModoInformado,
                                                "esespol": this.state.datosFormulario.esEspol,
                                                "fecharegistro": new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                                "aniocongreso": this.state.anioEvento, //"2022",     //TODO
                                                "pagado": this.state.datosFormulario.pagado,
                                                "idcongreso": this.state.datosFormulario.idCongreso,
                                                "tipoasistencia": this.state.datosFormulario.tipoAsistencia,
                                                "pais": this.state.datosFormulario.paisNom,
                                                "ciudad": this.state.datosFormulario.ciudadNom,
                                                "instituciondet": this.state.datosFormulario.tipoInstitucionDet,
                                                "tipoparticipantedet": this.state.datosFormulario.tipoParticipanteDet,
                                                "tipoestudiantedet": this.state.datosFormulario.tipoEstudianteDet,
                                                "participaciondet": this.state.datosFormulario.tipoParticipacionDet,
                                                "modoinformadodet": this.state.datosFormulario.modoInformadoDet,
                                                "esespoldet": this.state.datosFormulario.esEspolDet,
                                                "espostgradodet": this.state.datosFormulario.esPostgradoDet,
                                                "valorcongreso": this.state.datosFormulario.valorCIBB,
                                                "opactseleccionadas": this.sortOptSelectedString(this.state.datosFormulario.opActSeleccionadas),
                                                "grupopertenece": this.state.datosFormulario.grupoPertenece,
                                                "confirmarasistencia": this.state.datosFormulario.confirmarAsistencia,
                                                "aceptaavisotradatos": this.state.datosFormulario.aceptaAvisoTraDatos ? "S" : "N",
                                            })
                                        })
                                            .then(res => res.json())
                                            .then(async data => {
                                                //console.log(data);
                                                this.setState({ isLoading: false });
                                                // if data.estado === 0 fue exitoso y hago la redireccion a la pagina de pago
                                                if (data.estado === 0 && data.item !== null) {
                                                    window.location.href = process.env.REACT_APP_URI_PAGOS + data.item.strToken;
                                                    //window.location.href = "https://pagos.espol.edu.ec/pago/" + data.item.strToken;
                                                }
                                                // else se produjo un error, presentar swal con data.mensaje
                                                else {
                                                    Swal.fire({
                                                        title: "No se pudo completar el registro con el sistema de pago.",
                                                        text: (data.mensaje ?? "Error interno.") + " Vuelva a intentarlo más tarde.",
                                                        icon: "error"
                                                    }).then(_ => {
                                                        window.grecaptcha.reset();
                                                        this.handleRecaptchaChange(null);
                                                    });
                                                }
                                            });
                                    }
                                    //console.log(data);
                                    if (this.state.datosFormulario.tipoParticipacion === "A" &&
                                        this.state.datosFormulario.formaPago === "B") {
                                        //guardar comprobante de pago
                                        //console.log("Entro a subir comprobante");
                                        this.uploadComprobante(data.idcongresoregistro);
                                    }

                                }).catch((error) => {
                                    console.log(error);
                                    this.setState({ isLoading: false });
                                    Swal.fire({
                                        title: "No se pudo completar el registro.",
                                        text: "Datos ingresados no válidos. Vuelva a ingresar los datos.",
                                        icon: "error"
                                    }).then(_ => {
                                        window.grecaptcha.reset();
                                        this.handleRecaptchaChange(null);
                                    });
                                });
                        } else if (!this.isRegistrado) {   //usar false para nunca editar, por ahora solo se edita si se reversó el pago
                            //actualizar registro
                            //e.preventDefault();
                            //this.setCibbValor();
                            idCibb = data.tblCibbRegistro.idcongresoregistro;
                            const PUT_CIBB = JSON.stringify({
                                "idcongresoregistro": idCibb,
                                "apellidos": this.state.datosFormulario.apellidos,
                                "nombres": this.state.datosFormulario.nombres,
                                "numeroidentificacion": data.tblCibbRegistro.numeroidentificacion,
                                "idpais": data.tblCibbRegistro.idpais,
                                "idcanton": data.tblCibbRegistro.idcanton,
                                "tipoinstitucion": this.state.datosFormulario.tipoInstitucion,
                                "nombreinstitucion": this.state.datosFormulario.nombreInstitucion,
                                "tipoparticipante": this.state.datosFormulario.tipoParticipante,
                                "tipoestudiante": this.state.datosFormulario.tipoEstudiante,
                                "email": this.state.datosFormulario.email,
                                "celular": this.state.datosFormulario.celular,
                                "tipoparticipacion": this.state.datosFormulario.tipoParticipacion,
                                "rutapresentacion": this.state.datosFormulario.presentacion,
                                "modoinformado": this.state.datosFormulario.modoInformado,
                                "otromodoinformado": this.state.datosFormulario.otroModoInformado,
                                "esespol": this.state.datosFormulario.esEspol,
                                "fecharegistro": data.tblCibbRegistro.fecharegistro,
                                "aniocongreso": this.state.anioEvento, //"2022", //TODO
                                "idcongreso": data.tblCibbRegistro.idcongreso,
                                "tipoasistencia": this.state.datosFormulario.tipoAsistencia,
                                "opactseleccionadas": this.sortOptSelectedString(this.state.datosFormulario.opActSeleccionadas),
                                "grupopertenece": this.state.datosFormulario.grupoPertenece,
                                "pagado": 1, //this.state.datosFormulario.pagado, //NUEVO INTENTO PRERREGISTRO
                                "confirmarasistencia": this.state.datosFormulario.confirmarAsistencia,
                                "aceptaavisotradatos": this.state.datosFormulario.aceptaAvisoTraDatos ? "S" : "N",
                            });
                            this.setState({ isLoading: true });
                            //console.log(PUT_CIBB);
                            await fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/` + idCibb, {
                                method: 'PUT',
                                headers: { 'Content-Type': 'application/json', 'X-Recaptcha-Token': this.state.recaptchaToken },
                                body: PUT_CIBB
                            })
                                .then(res => res.json())
                                .then(async data => {
                                    //if (data.rutapresentacion !== null && data.rutapresentacion !== "") {
                                    //    this.uploadFile(data.idcongresoregistro);
                                    //}
                                    this.setState({ isLoading: false });
                                    Swal.fire({
                                        title: "¡Actualización exitosa!",
                                        text: "Sus datos han sido actualizados.",
                                        icon: "success"
                                    });
                                    if (this.state.datosFormulario.tipoParticipacion === "A" &&
                                        this.state.datosFormulario.formaPago === "T") {
                                        Swal.fire({
                                            title: "Redireccionando...",
                                            text: "Redireccionando a página de pago.",
                                            icon: "success"
                                        });
                                        this.setState({ isLoading: true });
                                        //Crear transaccion
                                        await fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/CrearTransaccionAPI`, {

                                            method: 'POST',
                                            headers: { 'Content-Type': 'application/json' },
                                            body: JSON.stringify({
                                                "idcongresoregistro": idCibb,
                                                "apellidos": this.state.datosFormulario.apellidos,
                                                "nombres": this.state.datosFormulario.nombres,
                                                "numeroidentificacion": this.state.datosFormulario.numeroIdentificacion,
                                                "idpais": this.state.datosFormulario.paisId,
                                                "idcanton": this.state.datosFormulario.ciudadId,
                                                "tipoinstitucion": this.state.datosFormulario.tipoInstitucion,
                                                "nombreinstitucion": this.state.datosFormulario.nombreInstitucion,
                                                "tipoparticipante": this.state.datosFormulario.tipoParticipante,
                                                "tipoestudiante": this.state.datosFormulario.tipoEstudiante,
                                                "email": this.state.datosFormulario.email,
                                                "celular": this.state.datosFormulario.celular,
                                                "tipoparticipacion": this.state.datosFormulario.tipoParticipacion,
                                                "rutapresentacion": this.state.datosFormulario.presentacion,
                                                "modoinformado": this.state.datosFormulario.modoInformado,
                                                "otromodoinformado": this.state.datosFormulario.otroModoInformado,
                                                "esespol": this.state.datosFormulario.esEspol,
                                                "fecharegistro": new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                                "aniocongreso": this.state.anioEvento, //"2022",
                                                "pagado": this.state.datosFormulario.pagado,
                                                "idcongreso": this.state.datosFormulario.idCongreso,
                                                "tipoasistencia": this.state.datosFormulario.tipoAsistencia,
                                                "pais": this.state.datosFormulario.paisNom,
                                                "ciudad": this.state.datosFormulario.ciudadNom,
                                                "instituciondet": this.state.datosFormulario.tipoInstitucionDet,
                                                "tipoparticipantedet": this.state.datosFormulario.tipoParticipanteDet,
                                                "tipoestudiantedet": this.state.datosFormulario.tipoEstudianteDet,
                                                "participaciondet": this.state.datosFormulario.tipoParticipacionDet,
                                                "modoinformadodet": this.state.datosFormulario.modoInformadoDet,
                                                "esespoldet": this.state.datosFormulario.esEspolDet,
                                                "espostgradodet": this.state.datosFormulario.esPostgradoDet,
                                                "valorcongreso": this.state.datosFormulario.valorCIBB,
                                                "opactseleccionadas": this.sortOptSelectedString(this.state.datosFormulario.opActSeleccionadas),
                                                "grupopertenece": this.state.datosFormulario.grupoPertenece,
                                                "confirmarasistencia": this.state.datosFormulario.confirmarAsistencia,
                                                "aceptaavisotradatos": this.state.datosFormulario.aceptaAvisoTraDatos ? "S" : "N",
                                            })
                                        })
                                            .then(res => res.json())
                                            .then(async data => {
                                                //console.log(data);
                                                this.setState({ isLoading: false });
                                                // if data.estado === 0 fue exitoso y hago la redireccion a la pagina de pago
                                                if (data.estado === 0 && data.item !== null) {
                                                    window.location.href = process.env.REACT_APP_URI_PAGOS + data.item.strToken;
                                                    //window.location.href = "https://pagos.espol.edu.ec/pago/" + data.item.strToken;
                                                }
                                                // else se produjo un error, presentar swal con data.mensaje
                                                else {
                                                    Swal.fire({
                                                        title: "No se pudo completar el registro con el sistema de pago.",
                                                        text: (data.mensaje ?? "Error interno.") + " Vuelva a intentarlo más tarde.",
                                                        icon: "error"
                                                    }).then(_ => {
                                                        window.grecaptcha.reset();
                                                        this.handleRecaptchaChange(null);
                                                    });
                                                }
                                            })
                                            .catch((error) => {
                                                console.log(error);
                                                this.setState({ isLoading: false });
                                                window.grecaptcha.reset();
                                                this.handleRecaptchaChange(null);
                                            });
                                    }

                                    if (this.state.datosFormulario.tipoParticipacion === "A" &&
                                        this.state.datosFormulario.formaPago === "B") {
                                        //guardar comprobante de pago
                                        this.uploadComprobante(idCibb);
                                    }

                                })
                                .catch((error) => {
                                    console.log(error);
                                    this.setState({ isLoading: false });
                                    window.grecaptcha.reset();
                                    this.handleRecaptchaChange(null);
                                });

                        }
                        else (
                            //Swal.fire({
                            //    title: "¡Formulario no válido!",
                            //    text: "Usuario ya registrado.",
                            //    icon: "error"
                            //})
                            Swal.fire({
                                title: "Participante ya registrado.",
                                text: "Usted ya se encuentra registrado para el evento.",
                                icon: "warning"
                            })
                            .then(_ => {
                                window.grecaptcha.reset();
                                this.handleRecaptchaChange(null);
                            })
                        )

                    })
                    .catch((error) => {
                        this.setState({ isLoading: false });
                        console.log(error);
                        window.grecaptcha.reset();
                        this.handleRecaptchaChange(null);
                    });

            }
            else if (formularioValido && !cuposDisponibles) {
                Swal.fire({
                    title: "¡Formulario no válido!",
                    text: "Durante su registro se han actualizados los cupos disponibles, por favor volver a revisar los grupos.",
                    icon: "error"
                });
            }
            else if (!(this.state.isDespuesRegInicio && this.state.isAntesRegFin)) {
                Swal.fire({
                    title: "¡Formulario no válido!",
                    text: this.state.isDespuesRegInicio ? "El formulario no acepta más registros." : "No ha empezado el periodo de registro.",
                    icon: "error"
                });
            }
            else {
                Swal.fire({
                    title: "¡Formulario no válido!",
                    text: "Asegúrese de llenar todos los campos obligatorios (campos con asterisco *), 10 dígitos en celular, 10 dígitos en cédula o entre 5 y 14 caracteres en pasaporte.",
                    icon: "error"
                });
            }
            //e.preventDefault();
            this.setState({
                onProcess: false
            });
        }
    }


    getEstadoEstudiante = (ced) => {
        const estadoEstudianteRequest = `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
  <soap:Body>
    <EstadoEstudiante xmlns="http://academico.espol.edu.ec/webservices/">
      <cedula>ced</cedula>
    </EstadoEstudiante>
  </soap:Body>
</soap:Envelope>`;

        fetch("https://ws.espol.edu.ec/saac/WSSAAC.asmx", {
            method: 'POST',
            headers: {
                'Host': 'ws.espol.edu.ec',
                'Content-Type': 'text/xml; charset=utf-8',
                'SOAPAction': "http://academico.espol.edu.ec/webservices/EstadoEstudiante"
            },
            body: estadoEstudianteRequest
        })
            .then((response) => console.log(response));
    }



    render() {
        var contenido = (this.state.datosFormulario.paises.length > 0 &&
            this.state.datosFormulario.opcionesActividades.length > 0 &&
            this.state.datosFormulario.opcionesGrupo.length > 0 &&
            this.state.evento !== 0) ?
            <>
                <center className="colorFcnm">
                    <h4 style={{ marginTop: "10px" }}>{this.state.titulo.replace(/([a-z])(?=[A-Z])|\s*\d{4}\b/g, function (m, g) {
                        return g ? g + " " : "";
                    })}</h4>
                    <h5>{this.state.anioEvento}</h5>
                </center>
                <br />
                <h5>Información para las inscripciones</h5>
                <br />
                {this.renderFormulario()}
            </>
            
            :
            (this.state.evento == 0 ? 
                <div>
                    <span>Evento no disponible</span>
                </div>
                :
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", fontSize: "16pt", marginTop: "10px" }}>
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden"></span>
                    </div>
                    <span><strong>Cargando Formulario...</strong></span>
                </div>
            )
                  
        return (
            <div>
                {contenido}
            </div>
        );
    }

    formatDateString(strDate) {
        //strDate yyyy-mm-dd
        if (this.expresiones.fecha1.test(strDate)) {
            return new Date(`${strDate}T00:00`).toLocaleDateString("es-EC", { year: "numeric", month: "long", day: "numeric" });
        }
        else {
            return strDate;
        }
    }

    extractDateFromText(text) {
        // Define months in Spanish
        const meses = {
            "enero": 0, "febrero": 1, "marzo": 2, "abril": 3, "mayo": 4, "junio": 5,
            "julio": 6, "agosto": 7, "septiembre": 8, "octubre": 9, "noviembre": 10, "diciembre": 11
        };

        // Updated regex: Capture both start and optional end time
        const regex = /(?:.*?\s)?(\w+),\s(\d{1,2})\sde\s(\w+)\.\s(\d{1,2}:\d{2})\s?[-–]?\s?(\d{1,2}:\d{2})?/;
        const match = text.match(regex);
        console.log(text, match);
        if (!match) return null; // If no match, return null

        const [, _, day, month, startTime, endTime] = match;
        const [startHours, startMinutes] = startTime.split(":").map(Number);
        const endDate = endTime ? endTime.split(":").map(Number) : null;

        // Get year
        const year = this.state.anioEvento;

        // Create Date objects
        const startDate = new Date(year, meses[month.toLowerCase()], day, startHours, startMinutes);
        const endDateObj = endDate ? new Date(year, meses[month.toLowerCase()], day, endDate[0], endDate[1]) : null;

        return { startDate, endDate: endDateObj };
    }

    //useEffect(() => {
    //    this.getOpcionesActividades();
    //    this.getOpcionesGrupo();
    //}, [this.state.evento]);

    renderFormulario() {

        

        return (
            <form
                name="formularioQUIM"
                className="formFCNM"
                //enctype="multipart/form-data" method="post"
                onSubmit={ this.onSubmit }
            >
                <Loading loading={this.state.isLoading} background="rgba(0,0,0,0.3)" loaderColor="#715491" />

                {!this.state.isDespuesRegInicio &&
                    <div className="alert alert-warning" role="alert">
                        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" />
                    <p className="alert-title"><i className="bi bi-exclamation-triangle-fill"></i><strong> ¡ADVERTENCIA! </strong></p>
                    <p>Este evento empieza la etapa de registro el día <strong>{this.formatDateString(this.state.fechaInicioInsc)}</strong>.</p>
                    </div>}
                {!this.state.isAntesRegFin &&
                    <div className="alert alert-warning" role="alert">
                        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" />
                    <p className="alert-title"><i className="bi bi-exclamation-triangle-fill"></i><strong> ¡ADVERTENCIA! </strong></p>
                        <p>Este evento ha culminado la etapa de registro el día <strong>{this.formatDateString(this.state.fechaFinInsc)}</strong>, por lo que no se aceptarán más participantes.</p>
                    </div>}

                <div>
                    <label className="form-label label-style">Elija su documento de identificación <span className="required-span">*</span></label>
                </div>

                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoIdentificacion"
                        id="CedulaRadio"
                        onChange={this.handleChange}
                        value="C"
                        defaultChecked
                    />
                    <label className="form-check-label" htmlFor="CedulaRadio">Cédula</label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoIdentificacion"
                        id="PasaporteRadio"
                        onChange={this.handleChange}
                        value="P"
                    />
                    <label className="form-check-label" htmlFor="PasaporteRadio">Pasaporte - Documento Nacional de Identidad</label>
                </div>
                <br />
                {this.state.datosFormulario.tipoIdentificacion === "C" &&
                    <>
                    <div className="mb-3">
                        <label htmlFor="cedula" className="form-label label-style">Cédula <span className="required-span">*</span></label>
                        <input
                            className="form-control"
                            id="cedula"
                            maxLength={10}
                            onChange={this.handleChange}
                            type="text"
                            name="numeroIdentificacion"
                            value={this.state.datosFormulario.cedula}
                            //pattern="[0-9]{10}"
                            onKeyDown={
                                function (e) {
                                    if ((e.keyCode < 48 || e.keyCode > 57) && //fuera del rango de numeros
                                        (e.keyCode < 37 || e.keyCode > 40) && //fuera del rango de teclas de flecha
                                        (e.keyCode < 96 || e.keyCode > 105) && //fuera del rango de numeros en teclado numerico
                                        e.keyCode !== 8 && //tecla backspace
                                        !e.ctrlKey &&
                                        e.keyCode !== 46 //tecla delete
                                    ) {
                                        e.preventDefault();
                                        //Swal.fire(
                                        //    "¡Caracter no válido!",
                                        //    "Ingrese solo 10 dígitos en el campo cédula",
                                        //    "error"
                                        //)
                                    }
                                }
                            }
                        />
                    </div>
                    </>
                }

                {this.state.datosFormulario.tipoIdentificacion === "P" &&
                    <>
                    <div className="mb-3">
                        <label htmlFor="pasaporte" className="form-label label-style">Pasaporte - Documento Nacional de Identidad <span className="required-span">*</span></label>
                        <input
                            className="form-control"
                            id="pasaporte"
                            maxLength={14}
                            onChange={this.handleChange}
                            type="text"
                            name="numeroIdentificacion"
                            value={this.state.datosFormulario.cedula}
                            onKeyDown={
                                function (e) {
                                    //keycode 32 es barra espaciadora
                                    if (e.keyCode === 32) {
                                        e.preventDefault();
                                    }
                                }
                            }
                        />
                    </div>
                    </>
                }
                <br/>
                <div>
                    <label className="form-label label-style">Datos que se mostrarán en el certificado: <span className="required-span"></span></label>
                </div>
                <ul>
                    <li>
                        <div>
                            <label htmlFor="nombres" className="form-label label-style">Nombres Completos <span className="required-span">*</span></label>
                            <input
                                className="form-control"
                                id="nombres"
                                maxLength={50}
                                onChange={this.handleChange}
                                type="text"
                                name="nombres"
                                value={this.state.datosFormulario.nombres}
                                onKeyDown={
                                    function (e) {
                                        //keycode 190 es el punto
                                        if (e.keyCode === 190) {
                                            e.preventDefault();
                                        }
                                    }
                                }
                            />
                        </div>
                    </li>
                    <br/>
                    <li>
                        <div>
                            <label htmlFor="apellidos" className="form-label label-style">Apellidos Completos <span className="required-span">*</span></label>
                            <input
                                className="form-control"
                                id="apellidos"
                                maxLength={50}
                                onChange={this.handleChange}
                                type="text"
                                name="apellidos"
                                value={this.state.datosFormulario.apellidos}
                                onKeyDown={
                                    function (e) {
                                        //keycode 190 es el punto
                                        if (e.keyCode === 190) {
                                            e.preventDefault();
                                        }
                                    }
                                }
                            />
                        </div>
                    </li>
                </ul>
                

                <br />

                <div>
                    <label htmlFor="paisesSelect" className="form-label label-style">País <span className="required-span">*</span></label>
                    <div>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="paisId"
                            onChange={this.handleChange}
                            id="paisesSelect"
                            value={this.state.datosFormulario.paisId??0}
                        >
                            <option key={0} value={0}>País / Country *</option>
                            {this.state.datosFormulario.paises.map((pais) => <option key={pais.siIdPais} value={pais.siIdPais}> {pais.strNombre} </option>)}
                        </select>
                    </div>
                </div>
                <br />



                <div>
                    <label htmlFor="ciudadesSelect" className="form-label label-style">Ciudad <span className="required-span">*</span></label>
                    <div>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="ciudadId"
                            onChange={this.handleChange}
                            value={this.state.datosFormulario.ciudadId}
                            id="ciudadesSelect"
                        >
                            <option>Ciudad / City *</option>
                            {this.state.datosFormulario.ciudades.map((ciudad) => <option key={ciudad.siIdCanton} value={ciudad.siIdCanton}> {ciudad.strNombreCanton} </option>)}
                        </select>
                    </div>
                </div>
                <br />
                

                <div>
                    <label className="form-label label-style">¿Desde qué institución se registra? <span className="required-span">*</span></label>
                </div>

                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoInstitucion"
                        id="empresa"
                        onChange={this.handleChange}
                        value="E"
                    />
                    <label className="form-check-label" htmlFor="empresa">Empresa</label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoInstitucion"
                        id="universidad"
                        onChange={this.handleChange}
                        value="U"
                    />
                    <label className="form-check-label" htmlFor="universidad">Universidad</label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoInstitucion"
                        id="otros"
                        onChange={this.handleChange}
                        value="O"
                    />
                    <label className="form-check-label" htmlFor="otros">Otro</label>
                </div>
                <br />
                <>
                    <div>
                        <label htmlFor="nombreInstitucion" className="form-label label-style">Indique el nombre de la institución <span className="required-span">*</span></label>
                        <input
                            className="form-control"
                            id="nombreInstitucion"
                            maxLength={255}
                            onChange={this.handleChange}
                            type="text"
                            name="nombreInstitucion"
                            value={this.state.datosFormulario.nombreInstitucion}
                            onKeyDown={
                                function (e) {
                                    //keycode 190 es el punto
                                    if (e.keyCode === 190) {
                                        e.preventDefault();
                                    }
                                }
                            }
                        />
                    </div>
                    <br />
                </>                    
                

                <div>
                    <label className="form-label label-style">Elija su tipo de participación <span className="required-span">*</span></label>
                </div>


                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoParticipante"
                        id="profesional"
                        onChange={this.handleChange}
                        value="P"
                    />
                    <label className="form-check-label" htmlFor="profesional">Profesional</label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoParticipante"
                        id="estudiante"
                        onChange={ this.handleChange }
                        value="E"
                    />
                    <label className="form-check-label" htmlFor="estudiante">Estudiante</label>
                </div>
                <br />

                
                {this.state.datosFormulario.tipoParticipante === "E" &&
                    <>
                        <div>
                        <label className="form-label label-style">Elejir su nivel de formación <span className="required-span">*</span></label>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="tipoEstudiante"
                                    id="pregrado"
                                    onChange={this.handleChange}
                                    value="B"
                                />
                            <label className="form-check-label" htmlFor="pregrado">Pregrado</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="tipoEstudiante"
                                    id="postgrado"
                                    onChange={this.handleChange}
                                    value="A"
                                />
                            <label className="form-check-label" htmlFor="postgrado">Postgrado</label>
                            </div>
                        </div>
                        <br />
                    </>
                }

                <div>
                    <label htmlFor="email" className="form-label label-style">Correo electrónico <span className="required-span">*</span></label>
                    <input                        
                        className="form-control"
                        id="email"
                        maxLength={40}
                        placeholder="Ingrese correo electrónico / Enter email"
                        onChange={this.handleChange}
                        name="email"
                        type="email"
                        value={this.state.datosFormulario.email}
                    />
                </div>
                <br />
                
                
                <div>
                    <label htmlFor="celular" className="form-label label-style">Número de celular <span className="required-span">*</span></label>
                    <input
                        className="form-control"
                        id="celular"
                        maxLength={10}
                        onChange={this.handleChange}
                        type="text"
                        name="celular"
                        value={this.state.datosFormulario.celular}
                        onKeyDown={
                            function (e) {
                                if ((e.keyCode < 48 || e.keyCode > 57) && //fuera del rango de numeros
                                    (e.keyCode < 37 || e.keyCode > 40) && //fuera del rango de teclas de flecha
                                    (e.keyCode < 96 || e.keyCode > 105) && //fuera del rango de numeros en teclado numerico
                                    e.keyCode !== 8 && //tecla backspace
                                    !e.ctrlKey &&
                                    e.keyCode !== 46 //tecla delete
                                ) {
                                    e.preventDefault();
                                    //Swal.fire(
                                    //    "¡Caracter no válido!",
                                    //    "Ingrese solo 10 dígitos en el campo celular",
                                    //    "error"
                                    //)
                                }
                            }
                        }
                    />
                </div>
                <br />


                <div>
           
                    {/*<label className="form-label label-style">Elija su participación en el VI CIBB / Choose your participation in the VI CIBB <span className="required-span">*</span></label>*/}

                    {/*<div className="form-check">*/}
                    {/*    <input*/}
                    {/*        className="form-check-input"*/}
                    {/*        type="radio"*/}
                    {/*        name="tipoParticipacion"*/}
                    {/*        id="oral"                           */}
                    {/*        onChange={this.handleChange}*/}
                    {/*        value="O"*/}
                    {/*    />*/}
                    {/*    <label className="form-check-label" htmlFor="oral">Presentación oral / Oral Presentation</label>*/}
                    {/*</div>*/}

                    {/*<div className="form-check">*/}
                    {/*    <input*/}
                    {/*        className="form-check-input"*/}
                    {/*        type="radio"*/}
                    {/*        name="tipoParticipacion"*/}
                    {/*        id="audiocartel"*/}
                    {/*        onChange={this.handleChange}*/}
                    {/*        value="P"*/}
                    {/*    />*/}
                    {/*    <label className="form-check-label" htmlFor="audiocartel">Presentación de audiocartel / Audio poster Presentation</label>*/}
                    {/*</div>*/}

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="hidden"
                            name="tipoParticipacion"
                            id="asistente"
                            onChange={this.handleChange}
                            value="A"
                        />
                        {/*<label className="form-check-label" htmlFor="asistente">Asistente / Assistant</label>*/}
                    </div>
                    <br />

                    {/*<div>*/}
                    {/*    <p>Descargar la guía para la presentación de resúmenes <a href="http://www.cibb.espol.edu.ec/sites/cibb.espol.edu.ec/files/Gu%C3%ADa%20para%20la%20presentaci%C3%B3n%20de%20res%C3%BAmenes.pdf" target="_blank" rel="noopener noreferrer">aquí</a>.</p>*/}
                    {/*    <p>Download the guide for the presentation of abstracts <a href="http://www.cibb.espol.edu.ec/sites/cibb.espol.edu.ec/files/Gu%C3%ADa%20para%20la%20presentaci%C3%B3n%20de%20res%C3%BAmenes.pdf" target="_blank" rel="noopener noreferrer">here</a>.</p>*/}
                    {/*</div>*/}

                    <div>
                        {(this.state.datosFormulario.tipoParticipacion === "O" || this.state.datosFormulario.tipoParticipacion === "P") &&                            
                            <div>
                            <label htmlFor="presentacion" className="form-label label-style">Cargar presentación (archivo PDF)/ Upload your Presentation (PDF file)<span className="required-span">*</span></label>
                            <input
                            onChange={(e) => {
                                //console.log(e.target.files[0].name);
                                var dto = this.state.datosFormulario;
                                dto.presentacion = e.target.files[0].name;
                                this.setState({ datosFormulario: dto });
                                }
                            }
                            className="form-control"
                            type="file"
                            id="presentacion"
                            accept=".pdf"
                            name="presentacion" />
                            </div>                            
                    }

                    </div>
                </div>
                {/*<br />*/}
                <div>
                    <label className="form-label label-style">Indicar el grupo de la Comunidad Politécnica al cual pertenece usted: <span className="required-span">*</span></label>
                    <select
                        className="form-control"
                        aria-label="Default select example"
                        name="grupoPertenece"
                        onChange={this.handleChange}
                        id="grupoPertenece"
                        disabled
                    >
                        {this.state.datosFormulario.opcionesGrupo.map((item) => <option key={item.indice} value={item.indice}> {item.titular} </option>)}
                    </select>
                </div>
                <br />
                {this.state.datosFormulario.tipoParticipante === "E" && this.state.datosFormulario.tipoEstudiante === "B" &&
                    <div className="alert-fcnm alert">
                    <p>Para participar en la Escuela de Verano de Química debe haber aprobado la materia <strong>Fundamentos de Programación</strong></p>
                    <p>Si usted es estudiantes del nivel 200I o 200II deberá asistir a <strong>LOS DOS CURSOS VIRTUALES</strong> a dictarse: Python o Aspen Plus, para poder recibir su certificado de participación.</p>
                </div>
                }
                {/*<div>*/}
                {/*    <label className="form-label label-style">Confirmar asistencia al día de la clausura (viernes 12 de mayo 13H00 - 14H00) <span className="required-span">*</span></label>*/}
                {/*    <div className="form-check">*/}
                {/*        <input*/}
                {/*            className="form-check-input"*/}
                {/*            type="radio"*/}
                {/*            name="confirmarAsistencia"*/}
                {/*            id="confirmarAsistenciasi"*/}
                {/*            onChange={this.handleChange}*/}
                {/*            value="S"*/}
                {/*        />*/}
                {/*        <label className="form-check-label" htmlFor="si">Si</label>*/}
                {/*    </div>*/}

                {/*    <div className="form-check">*/}
                {/*        <input*/}
                {/*            className="form-check-input"*/}
                {/*            type="radio"*/}
                {/*            name="confirmarAsistencia"*/}
                {/*            id="confirmarAsistenciano"*/}
                {/*            onChange={this.handleChange}*/}
                {/*            value="N"*/}
                {/*        />*/}
                {/*        <label className="form-check-label" htmlFor="no">No</label>*/}
                {/*    </div>*/}
             
                {/*</div>*/}
                <div>
                    <label className="form-label label-style">Itinerario: <span className="required-span"></span></label>
                    <div className="">
                        {this.state.datosFormulario.opcionesActividadesGrupos
                            .sort((a, b) => a.numFecha - b.numFecha)
                            .map((grupoAct, index) => {
                                return (
                                    <Fragment key={index}>
                                        <div
                                            style={{ fontWeight: "bolder", margin: "5px 0" }}
                                        >
                                            {grupoAct.strFecha}.
                                            {/*{(grupoAct.opcionesActividadesList.some(oa => oa.titular.includes("Visita técnica"))) &&*/}
                                            {/*    <strong className="colorFcnm" >&nbsp;Confirme su asistencia a la Visita Técnica.</strong>*/}
                                            {/*}*/}
                                        </div>
                                            <ul>
                                            {
                                                grupoAct.opcionesActividadesList
                                                    //.sort((a, b) => {
                                                    //    let gruposa = a.grupos.map(g => {
                                                    //        let newFechas = g.fechasDate.filter(f => new Date(f.startDate).setHours(0, 0, 0, 0) == grupoAct.numFecha)
                                                    //        return { ...g, fechasDate: newFechas}
                                                    //    })
                                                    //    let gruposb = b.grupos.map(g => {
                                                    //        let newFechas = g.fechasDate.filter(f => new Date(f.startDate).setHours(0, 0, 0, 0) == grupoAct.numFecha)
                                                    //        return { ...g, fechasDate: newFechas }
                                                    //    })
                                                    //    let gruposaq = a.grupos.filter(g => new Date(g.fechasDate.filter(f => new Date(f.startDate).setHours(0, 0, 0, 0) == grupoAct.numFecha)[0]?.startDate).setHours(0, 0, 0, 0) == grupoAct.numFecha)
                                                    //    let gruposbq = b.grupos.filter(g => new Date(g.fechasDate.filter(f => new Date(f.startDate).setHours(0, 0, 0, 0) == grupoAct.numFecha)[0]?.startDate).setHours(0, 0, 0, 0) == grupoAct.numFecha)
                                                    //    //console.log(gruposa, gruposb)
                                                    //    return (gruposa[0].fechasDate[0]?.startDate - gruposb[0].fechasDate[0]?.startDate)
                                                    //})
                                                    .map(({ indice, titular, fecha, adicional, grupos, info, idActSameStart }, index) => {
                                                        let isVisitaTecnica = titular.includes("Visita técnica")
                                                        return (grupos.map((data) => { return data.cupo != 0 ? (data.disponible < 0 ? 0 : data.disponible) : 1 }).reduce((accumulator, currentValue) => {
                                                            return accumulator + currentValue
                                                        }, 0) >= 1 ?
                                                            <li className="outer-li" key={indice} >
                                                                <div className="form-check" key={indice}>
                                                                    <div className="toppings-list-item">
                                                                        <div className="left-section">
                                                                            <label className="form-check-label" htmlFor={`custom-checkbox-${indice}`}>
                                                                                {(/*isVisitaTecnica ||*/ false) && grupos.length <= 1 &&  //fecha.length
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="mr-2"
                                                                                    key={"act" + indice}
                                                                                        id={`custom-checkbox-${indice}`}
                                                                                    name={"item" + indice}
                                                                                        value={indice}
                                                                                    onChange={this.handleCheck}
                                                                                //disabled={grupos[0].disponible == 0 && grupos[0].cupo!=0}
                                                                                />
                                                                                }
                                                                                {
                                                                                    idActSameStart && grupos.length <= 1 &&
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        name={idActSameStart}
                                                                                        id={`custom-checkbox-${indice}`}
                                                                                        onChange={this.handleCheckGroupRadio}
                                                                                        value={indice}
                                                                                    />
                                                                                }
                                                                                <b className="">
                                                                                    {isVisitaTecnica ? 
                                                                                        <strong className="colorFcnm" >{titular}</strong>
                                                                                        :
                                                                                        titular
                                                                                    }
                                                                                    {(grupos.length > 1) &&
                                                                                        <strong className="colorFcnm" >&nbsp;Seleccione un grupo de su preferencia.</strong>
                                                                                    }
                                                                                    {/*{titular}*/} {/*{idActSameStart.toString()}*/}
                                                                                </b>
                                                                            </label>
                                                                        </div>
                                                                        <div>
                                                                            {info &&

                                                                                <label className={`labelinfo${indice}`}>
                                                                                    {info}
                                                                                </label>
                                                                            }
                                                                            {/*{false && idActSameStart && */}
                                                                            {/*        <label className="labelAdicional" key={"sameHorario" + indice}*/}
                                                                            {/*            id={`custom-ip-${idActSameStart}`}>*/}
                                                                            {/*            */}{/*{"*".repeat(adicional?.length ?? 0)}*Cruce con otra actividad*/}
                                                                            {/*        </label>*/}
                                                                            {/*}*/}
                                                                        </div>
                                                                        <div>
                                                                            {adicional != null && adicional != undefined &&
                                                                                adicional.map((data, index3) => {
                                                                                    return (
                                                                                        <label className="labelAdicional" key={"adic" + indice + index3}
                                                                                            id={`custom-ip-${index3}`}>
                                                                                            {data}
                                                                                        </label>
                                                                                    );
                                                                                })}
                                                                        {/*{false && idActSameStart && */}
                                                                        {/*        <label className="labelAdicional" key={"sameHorario" + indice}*/}
                                                                        {/*            id={`custom-ip-${idActSameStart}`}>*/}
                                                                        {/*            */}{/*{"*".repeat(adicional?.length ?? 0)}*Cruce con otra actividad*/}
                                                                        {/*        </label>*/}
                                                                        {/*}*/}
                                                                    </div>
                                                                <div className="right-section">
                                                                            <ul style={grupos.length > 1 ? {
                                                                                listStyleType: 'none',
                                                                                paddingLeft: 20
                                                                            } : {}}>
                                                                        {
                                                                            grupos.map((data, index2) => {    //fecha.map

                                                                            if (isVisitaTecnica) {
                                                                                return (<div
                                                                                    key={"fec" + indice + index2}
                                                                                    style={{ display: 'flex', flexDirection: 'column' }}
                                                                                        >
                                                                                    <label className="form-check-label" htmlFor={`custom-checkbox-${indice}`}>
                                                                                        {grupos.length <= 1 &&  //fecha.length
                                                                                            <input
                                                                                                type="radio"
                                                                                                className="mr-2"
                                                                                                key={"act" + indice + "S"}
                                                                                                id={`custom-checkbox-${indice}`}
                                                                                                name={"item" + indice}
                                                                                                value={indice}
                                                                                            onChange={this.handleCheck}
                                                                                            required
                                                                                            //disabled={grupos[0].disponible == 0 && grupos[0].cupo!=0}
                                                                                            />
                                                                                        }
                                                                                        <b>Sí, asistiré (confirmo mi cupo)</b>
                                                                                    </label>
                                                                                    <label className="form-check-label" htmlFor={`custom-checkbox-${indice}-N`}>
                                                                                        {grupos.length <= 1 &&  //fecha.length
                                                                                            <input
                                                                                            type="radio"
                                                                                            className="mr-2"
                                                                                            key={"act" + indice + "N"}
                                                                                            id={`custom-checkbox-${indice}-N`}
                                                                                            name={"item" + indice}
                                                                                            value={indice}
                                                                                            onChange={(e) => {
                                                                                                this.handleCheck({ ...e, target: {...e.target, checked: false, value: e.target.value} });
                                                                                            }}
                                                                                            //disabled={grupos[0].disponible == 0 && grupos[0].cupo!=0}
                                                                                            />
                                                                                        }
                                                                                        <b>No asistiré</b>
                                                                                    </label>
                                                                                </div>)
                                                                                        
                                                                                }

                                                                                let fechaGrupo = data.fechasDate.map(f => new Date(f.startDate).setHours(0, 0, 0, 0));
                                                                                if (!fechaGrupo.some(f => f == grupoAct.numFecha)) {
                                                                                    return (<Fragment key={"fec" + indice + index2}></Fragment>)
                                                                                }
                                                                                return (
                                                                                    <li className="liActividad" key={"fec" + indice + index2}
                                                                                        id={`custom-p-${indice}_${index2}`}>
                                                                                        <div
                                                                                            style={{ display: 'flex', alignItems: 'baseline' }}
                                                                                        >
                                                                                            {grupos.length > 1 &&       //fecha.length  data
                                                                                                <label style={{ display: "flex", alignItems: "baseline" }} className="" htmlFor={`custom-checkbox-${indice}_${index2}`}>

                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                className="mr-2"
                                                                                                key={"act" + indice + index2}
                                                                                                id={`custom-checkbox-${indice}_${index2}`}
                                                                                                    name={"item" + indice}
                                                                                                    value={indice + "_" + index2}
                                                                                                    onChange={this.handleCheckGroup}
                                                                                                    disabled={data.disponible <= 0 && data.cupo != 0}
                                                                                                />
                                                                                                <span style={{ marginBottom: "5px", marginTop: "5px"}}>
                                                                                                    {data.titulo}
                                                                                                    {data.titulo && <br />}
                                                                                                    {data.fecha}
                                                                                                    <br />
                                                                                                    {data.cupo != 0 && <strong className={data.disponible <= 0 ? "alertColor" : ""}> Cupos disponibles: {data.disponible}/{data.cupo}</strong>}
                                                                                                </span>
                                                                                                </label>
                                                                                            }
                                                                                            {
                                                                                                grupos.length <= 1 &&
                                                                                                <div style={{ marginBottom: "5px", marginTop: "5px" }}>
                                                                                                    {data.titulo}
                                                                                                    {data.titulo && <br />}
                                                                                                    {data.fecha}
                                                                                                    <br />
                                                                                                    {data.cupo != 0 && <strong className={data.disponible <= 0 ? "alertColor" : ""}> Cupos disponibles: {data.disponible}/{data.cupo}</strong>}
                                                                                                </div>
                                                                                            }
                                                                                        </div>
                                                                                    </li>
                                                                                );
                                                                            })
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </li>
                                                        :
                                                        <div key={indice}></div>
                                                        );
                                                    }
                                                )
                                            }
                                            </ul>
                                    </Fragment>)
                            })
                        }
                    </div>
                    {/*<div className="form-check">*/}
                    {/*    <input*/}
                    {/*        className="form-check-input"*/}
                    {/*        type="checkbox"*/}
                    {/*        name="activity1"*/}
                    {/*        id="act1"*/}
                    {/*        onChange={this.handleChangeAct1}*/}
                    {/*        value="1"*/}
                    {/*    />*/}
                    {/*    <label className="form-check-label" htmlFor="act1">Charla: El ingeniero químico como emprendedor en el sector Agroindustrial. Cerquié, un caso de estudio.</label>*/}
                    {/*</div>*/}
                    {/*<div className="form-check">*/}
                    {/*    <input*/}
                    {/*        className="form-check-input"*/}
                    {/*        type="checkbox"*/}
                    {/*        name="activity2"*/}
                    {/*        id="act1"*/}
                    {/*        onChange={this.handleChangeAct2}*/}
                    {/*        value="2"*/}
                    {/*    />*/}
                    {/*    <label className="form-check-label" htmlFor="act2">Charla: Buenas prácticas de manufactura.</label>*/}
                    {/*</div>*/}
                    {/*<div className="form-check">*/}
                    {/*    <input*/}
                    {/*        className="form-check-input"*/}
                    {/*        type="checkbox"*/}
                    {/*        name="activity3"*/}
                    {/*        id="act3"*/}
                    {/*        onChange={this.handleChangeAct3}*/}
                    {/*        value="3"*/}
                    {/*    />*/}
                    {/*    <label className="form-check-label" htmlFor="act2">Charla: Buenas prácticas de manufactura.</label>*/}
                    {/*</div>*/}


                </div>
                {/*&& this.state.datosFormulario.tipoParticipacion === "A"*/}
                {this.state.datosFormulario.pagado != 2  &&
                    <>                    
                    <div>
                        <label className="form-label label-style">Elija el método de pago <span className="required-span">*</span></label>
                    </div>
                    <label className="colorFcnm">Comunidad politécnica ${this.state.valorInternos}, Externos ${this.state.valorExternos}.</label>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="formaPago"
                            id="transferencia"
                            onChange={this.handleChange}
                            value="B"
                        />
                        <label className="form-check-label" htmlFor="transferencia">Transferencia bancaria</label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="formaPago"
                            id="tarjeta"
                            onChange={this.handleChange}
                            value="T"
                        />
                        <label className="form-check-label" htmlFor="tarjeta">Tarjeta de crédito/débito</label>
                    </div>
                    <br />

                    {this.state.datosFormulario.formaPago === "B" &&
                        <>
                        <div className="infoTransferencia">
                            <label className="label-style">Datos para la transferencia bancaria</label>

                            <table className="tablaInfoBanco">
                                <tbody>
                                    <tr>
                                        <th colSpan="2">Banco del Pacifico</th>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Código Swift:</td>
                                        <td>PACIECEG</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Dirección del Banco:</td>
                                        <td>P. Icaza 200 y Pedro Carbo</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Nombre del Cliente:</td>
                                        <td>Empresa Pública de Servicios ESPOL-TECH E.P.</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Número de Cuenta:</td>
                                        <td>7427786</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Tipo de Cuenta:</td>
                                        <td>Cuenta Corriente (Rotativa de Ingresos)</td>
                                    </tr>
                                </tbody>
                            </table>
                            <br/>
                            <table className="tablaInfoBanco">
                                <tbody>
                                    <tr>
                                        <th colSpan="2">Banco de Guayaquil</th>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Código Swift:</td>
                                        <td>GUAYECEG</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Dirección del Banco:</td>
                                        <td>Pichincha 107 y P. Icaza</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Nombre del Cliente:</td>
                                        <td>Empresa Pública de Servicios ESPOL-TECH E.P.</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Número de Cuenta:</td>
                                        <td>11138640</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Tipo de Cuenta:</td>
                                        <td>Cuenta Corriente (Rotativa de Ingresos)</td>
                                    </tr>
                                </tbody>                               
                            </table>
                            <br />
                            <table className="tablaInfoBanco">
                                <tbody>
                                    <tr>
                                        <th colSpan="2">Banco de Pichincha</th>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Código Swift:</td>
                                        <td>PICHECEQ</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Dirección del Banco:</td>
                                        <td>Av. Francisco de Orellana y Justino Cornejo, Mezanine</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Nombre del Cliente:</td>
                                        <td>Empresa Pública de Servicios ESPOL-TECH E.P.</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Número de Cuenta:</td>
                                        <td>2100300388</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Tipo de Cuenta:</td>
                                        <td>Cuenta Corriente (Rotativa de Ingresos)</td>
                                    </tr>
                                </tbody>                               
                            </table>
                            <br/>
                            <p><b>Mail:</b> <a href="mailto:financierofcnm@espol.edu.ec?subject=Registro a la ESCUELA DE INGENIERÍA QUÍMICA">financierofcnm@espol.edu.ec</a></p>
                            <br/>
                                {/*<p><b>A nombre de:</b> Empresa Pública de Servicios ESPOL-TECH E.P.</p>*/}
                                {/*<p><b>RUC:</b> 0968592010001</p>*/}
                                {/*<p><b>Banco:</b> Banco del Pacífico</p>*/}
                                {/*<p><b>Tipo de cuenta:</b> Cuenta corriente</p>*/}
                                {/*<p><b>Número de cuenta:</b> 7427788</p>*/}

                                {/*<p><b>Banco:</b> Banco de Guayaquil</p>*/}
                                {/*<p><b>Tipo de cuenta:</b> Cuenta corriente</p>*/}
                                {/*<p><b>Número de cuenta:</b> 11138640</p>*/}
                                {/*<p><b>Mail:</b> <a href="mailto:tesorespoltech@espol.edu.ec,sjbravo@espol.edu.ec?subject=Gracias por registrarte a la ESCUELA DE INGENIERÍA QUÍMICA">tesorespoltech@espol.edu.ec; sjbravo@espol.edu.ec</a></p>*/}
                            </div>

                            <div>
                                <label htmlFor="comprobantePago" className="form-label label-style">Adjuntar comprobante de pago (archivo PDF) <span className="required-span">*</span></label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="comprobantePago"
                                    name="comprobantePago"
                                    accept=".pdf"
                                    //accept=".jpg, .jpeg, .png, .pdf"
                                />
                            </div>
                            <br />
                        </>
                    }
                    
                        
                    </>                    
                }
                {this.state.datosFormulario.pagado === 2 &&
                    <>
                        <div>
                            <label className="form-label label-style">Elija el método de pago </label>
                        </div>
                        <label className="colorFcnm">Comunidad politécnica ${this.state.valorInternos}, Externos ${this.state.valorExternos }.</label>
                        <br/><label className="colorFcnm">Su registro ya se encuentra pagado.</label>
                    </>                
                }
                <div style={{ display: "flex"}}>
                    <input
                        type="checkbox"
                        className="mr-2 mb-2"
                        key={"aceptaTerminos"}
                        id={`aceptaTerminos`}
                        required
                        name={"aceptaTerminos"}
                        checked={this.state.datosFormulario.aceptaTerminos}
                        onInvalid={ (e) => e.target.setCustomValidity("Aceptar los Términos y Condiciones para continuar.") }
                        onChange={(e) => { this.handleChange(e); e.target.setCustomValidity("") }}
                        title="Aceptar términos y condiciones"
                    />
                    <label htmlFor="aceptaTerminos" className="">Acepto los&nbsp;</label><a style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => this.showTerms()}>Términos y Condiciones</a> <span className="required-span">*</span>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                        type="checkbox"
                        className="mr-2 mb-2"
                        key={"aceptaAvisoTraDatos"}
                        id={`aceptaAvisoTraDatos`}
                        required
                        name={"aceptaAvisoTraDatos"}
                        checked={this.state.datosFormulario.aceptaAvisoTraDatos}
                        onInvalid={(e) => e.target.setCustomValidity("Aceptar el Aviso Legal de Tratamiento de Datos.")}
                        onChange={(e) => { this.handleChange(e); e.target.setCustomValidity("") }}
                        title="Aceptar el Aviso Legal de Tratamiento de Datos"
                    />
                    <label htmlFor="aceptaAvisoTraDatos" className="">Acepto el&nbsp;</label><a style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => this.showTermsTratamiento()}>Aviso Legal de Tratamiento de Datos</a> <span className="required-span">*</span>
                </div>

                <div className="alert-fcnm alert">
                    <p>Gracias por tu interés en participar en la Escuela de Ingeniería Química. Estamos seguros de que será un tiempo muy provechoso. Espera información detallada en el correo que ingresaste en el registro. Si tienes dudas, escribir a <a href="mailto:escuelaiq@espol.edu.ec">escuelaiq@espol.edu.ec</a>.</p>
                </div>
                <div>                    
                    {!this.state.isRegistrado &&
                        <>
                            <ReCAPTCHA
                                sitekey={process.env.REACT_APP_SITE_KEY}
                                onChange={this.handleRecaptchaChange}
                        />
                        <br/>
                            <button type="submit" className="btn btn-secondary bgFncm" style={{ marginBottom: "16px" }} disabled={ /*false &&*/ !(this.state.isDespuesRegInicio && this.state.isAntesRegFin)}>Registrar</button>
                        </>
                    }
                    {this.state.isRegistrado && <div className="alert alert-danger" role="alert">
                        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" />
                        <p className="alert-title"><i className="bi bi-x-circle"></i> ADVERTENCIA! </p>
                        <p>Usted ya se encuentra {this.state.datosFormulario.pagado === 1 ? "prerregistrado":"registrado"} en este evento.</p>
                    </div>}
                </div>
            </form>
        )
    }
}

export default FormularioQuimica;